const mock = [
  {
    id: 313330998,
    node_id: "MDEwOlJlcG9zaXRvcnkzMTMzMzA5OTg=",
    name: "50projects50days",
    full_name: "bradtraversy/50projects50days",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/50projects50days",
    description: "50+ mini web projects using HTML, CSS & JS",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/50projects50days",
    forks_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/50projects50days/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/50projects50days/deployments",
    created_at: "2020-11-16T14:39:01Z",
    updated_at: "2021-11-04T03:53:06Z",
    pushed_at: "2021-10-20T07:09:08Z",
    git_url: "git://github.com/bradtraversy/50projects50days.git",
    ssh_url: "git@github.com:bradtraversy/50projects50days.git",
    clone_url: "https://github.com/bradtraversy/50projects50days.git",
    svn_url: "https://github.com/bradtraversy/50projects50days",
    homepage: null,
    size: 489,
    stargazers_count: 9640,
    watchers_count: 9640,
    language: "CSS",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2605,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 32,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 2605,
    open_issues: 32,
    watchers: 9640,
    default_branch: "master",
  },
  {
    id: 154967708,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTQ5Njc3MDg=",
    name: "A-to-Z-Resources-for-Students",
    full_name: "bradtraversy/A-to-Z-Resources-for-Students",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/A-to-Z-Resources-for-Students",
    description:
      "Curated list of resources for college students :octocat: If you like give a :star:",
    fork: true,
    url: "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students",
    forks_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/deployments",
    created_at: "2018-10-27T13:30:05Z",
    updated_at: "2021-10-28T00:09:37Z",
    pushed_at: "2019-10-08T18:51:01Z",
    git_url: "git://github.com/bradtraversy/A-to-Z-Resources-for-Students.git",
    ssh_url: "git@github.com:bradtraversy/A-to-Z-Resources-for-Students.git",
    clone_url:
      "https://github.com/bradtraversy/A-to-Z-Resources-for-Students.git",
    svn_url: "https://github.com/bradtraversy/A-to-Z-Resources-for-Students",
    homepage: "https://gitter.im/a2z-resources",
    size: 2546,
    stargazers_count: 300,
    watchers_count: 300,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 137,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 137,
    open_issues: 2,
    watchers: 300,
    default_branch: "master",
  },
  {
    id: 96554809,
    node_id: "MDEwOlJlcG9zaXRvcnk5NjU1NDgwOQ==",
    name: "a4app",
    full_name: "bradtraversy/a4app",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/a4app",
    description: "Angular 4 in 60 Minutes app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/a4app",
    forks_url: "https://api.github.com/repos/bradtraversy/a4app/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/a4app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/a4app/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/a4app/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/a4app/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/a4app/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/a4app/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/a4app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/a4app/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/a4app/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/a4app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/a4app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/a4app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/a4app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/a4app/statuses/{sha}",
    languages_url: "https://api.github.com/repos/bradtraversy/a4app/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/a4app/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/a4app/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/a4app/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/a4app/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/a4app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/a4app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/a4app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/a4app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/a4app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/a4app/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/a4app/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/a4app/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/bradtraversy/a4app/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/a4app/issues{/number}",
    pulls_url: "https://api.github.com/repos/bradtraversy/a4app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/a4app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/a4app/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/bradtraversy/a4app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/a4app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/a4app/deployments",
    created_at: "2017-07-07T16:03:26Z",
    updated_at: "2021-09-29T03:22:54Z",
    pushed_at: "2017-08-05T15:17:23Z",
    git_url: "git://github.com/bradtraversy/a4app.git",
    ssh_url: "git@github.com:bradtraversy/a4app.git",
    clone_url: "https://github.com/bradtraversy/a4app.git",
    svn_url: "https://github.com/bradtraversy/a4app",
    homepage: null,
    size: 14,
    stargazers_count: 82,
    watchers_count: 82,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 52,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 52,
    open_issues: 2,
    watchers: 82,
    default_branch: "master",
  },
  {
    id: 81346555,
    node_id: "MDEwOlJlcG9zaXRvcnk4MTM0NjU1NQ==",
    name: "acme_keystone",
    full_name: "bradtraversy/acme_keystone",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/acme_keystone",
    description: "Sample Keystone.js app with products",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/acme_keystone",
    forks_url: "https://api.github.com/repos/bradtraversy/acme_keystone/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/acme_keystone/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/acme_keystone/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/acme_keystone/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/acme_keystone/deployments",
    created_at: "2017-02-08T15:52:12Z",
    updated_at: "2021-09-20T15:23:22Z",
    pushed_at: "2017-02-08T15:55:26Z",
    git_url: "git://github.com/bradtraversy/acme_keystone.git",
    ssh_url: "git@github.com:bradtraversy/acme_keystone.git",
    clone_url: "https://github.com/bradtraversy/acme_keystone.git",
    svn_url: "https://github.com/bradtraversy/acme_keystone",
    homepage: null,
    size: 469,
    stargazers_count: 22,
    watchers_count: 22,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 10,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 10,
    open_issues: 0,
    watchers: 22,
    default_branch: "master",
  },
  {
    id: 111341681,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTEzNDE2ODE=",
    name: "adonis40blog",
    full_name: "bradtraversy/adonis40blog",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/adonis40blog",
    description: "Simple blog in AdonisJS 4.0",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/adonis40blog",
    forks_url: "https://api.github.com/repos/bradtraversy/adonis40blog/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/adonis40blog/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/adonis40blog/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/adonis40blog/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/adonis40blog/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/adonis40blog/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/adonis40blog/deployments",
    created_at: "2017-11-19T23:46:36Z",
    updated_at: "2021-09-19T19:24:52Z",
    pushed_at: "2017-11-19T23:51:10Z",
    git_url: "git://github.com/bradtraversy/adonis40blog.git",
    ssh_url: "git@github.com:bradtraversy/adonis40blog.git",
    clone_url: "https://github.com/bradtraversy/adonis40blog.git",
    svn_url: "https://github.com/bradtraversy/adonis40blog",
    homepage: null,
    size: 135,
    stargazers_count: 24,
    watchers_count: 24,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 18,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 18,
    open_issues: 0,
    watchers: 24,
    default_branch: "master",
  },
  {
    id: 24938686,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDkzODY4Ng==",
    name: "aioweb",
    full_name: "bradtraversy/aioweb",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/aioweb",
    description: "Full featured CMS written in PHP and Codeigniter framework",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/aioweb",
    forks_url: "https://api.github.com/repos/bradtraversy/aioweb/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/aioweb/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/aioweb/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/aioweb/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/aioweb/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/aioweb/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/aioweb/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/aioweb/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/aioweb/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/aioweb/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/aioweb/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/aioweb/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/aioweb/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/aioweb/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/aioweb/statuses/{sha}",
    languages_url: "https://api.github.com/repos/bradtraversy/aioweb/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/aioweb/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/aioweb/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/aioweb/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/aioweb/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/aioweb/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/aioweb/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/aioweb/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/aioweb/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/aioweb/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/aioweb/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/aioweb/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/aioweb/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/bradtraversy/aioweb/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/aioweb/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/aioweb/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/aioweb/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/aioweb/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/aioweb/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/aioweb/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/aioweb/deployments",
    created_at: "2014-10-08T12:02:16Z",
    updated_at: "2021-09-19T19:24:53Z",
    pushed_at: "2014-10-08T13:47:40Z",
    git_url: "git://github.com/bradtraversy/aioweb.git",
    ssh_url: "git@github.com:bradtraversy/aioweb.git",
    clone_url: "https://github.com/bradtraversy/aioweb.git",
    svn_url: "https://github.com/bradtraversy/aioweb",
    homepage: null,
    size: 952,
    stargazers_count: 9,
    watchers_count: 9,
    language: "PHP",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 9,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: {
      key: "gpl-3.0",
      name: "GNU General Public License v3.0",
      spdx_id: "GPL-3.0",
      url: "https://api.github.com/licenses/gpl-3.0",
      node_id: "MDc6TGljZW5zZTk=",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 9,
    open_issues: 2,
    watchers: 9,
    default_branch: "master",
  },
  {
    id: 229453338,
    node_id: "MDEwOlJlcG9zaXRvcnkyMjk0NTMzMzg=",
    name: "alexis_speech_assistant",
    full_name: "bradtraversy/alexis_speech_assistant",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/alexis_speech_assistant",
    description: "Python speech assist app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/alexis_speech_assistant",
    forks_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/deployments",
    created_at: "2019-12-21T16:23:53Z",
    updated_at: "2021-10-26T04:51:10Z",
    pushed_at: "2021-07-10T12:34:40Z",
    git_url: "git://github.com/bradtraversy/alexis_speech_assistant.git",
    ssh_url: "git@github.com:bradtraversy/alexis_speech_assistant.git",
    clone_url: "https://github.com/bradtraversy/alexis_speech_assistant.git",
    svn_url: "https://github.com/bradtraversy/alexis_speech_assistant",
    homepage: null,
    size: 21,
    stargazers_count: 237,
    watchers_count: 237,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 169,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 25,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 169,
    open_issues: 25,
    watchers: 237,
    default_branch: "master",
  },
  {
    id: 364923917,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjQ5MjM5MTc=",
    name: "angular-crash-2021",
    full_name: "bradtraversy/angular-crash-2021",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/angular-crash-2021",
    description: "Task tracker app from the 2021 youtube crash course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/angular-crash-2021",
    forks_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-2021/deployments",
    created_at: "2021-05-06T13:41:10Z",
    updated_at: "2021-11-04T04:12:49Z",
    pushed_at: "2021-05-06T21:10:50Z",
    git_url: "git://github.com/bradtraversy/angular-crash-2021.git",
    ssh_url: "git@github.com:bradtraversy/angular-crash-2021.git",
    clone_url: "https://github.com/bradtraversy/angular-crash-2021.git",
    svn_url: "https://github.com/bradtraversy/angular-crash-2021",
    homepage: null,
    size: 318,
    stargazers_count: 237,
    watchers_count: 237,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 335,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 335,
    open_issues: 1,
    watchers: 237,
    default_branch: "main",
  },
  {
    id: 167179237,
    node_id: "MDEwOlJlcG9zaXRvcnkxNjcxNzkyMzc=",
    name: "angular-crash-todolist",
    full_name: "bradtraversy/angular-crash-todolist",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/angular-crash-todolist",
    description: "Simple app for Angular crash course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/angular-crash-todolist",
    forks_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/angular-crash-todolist/deployments",
    created_at: "2019-01-23T12:25:21Z",
    updated_at: "2021-09-20T16:08:29Z",
    pushed_at: "2021-01-18T07:07:04Z",
    git_url: "git://github.com/bradtraversy/angular-crash-todolist.git",
    ssh_url: "git@github.com:bradtraversy/angular-crash-todolist.git",
    clone_url: "https://github.com/bradtraversy/angular-crash-todolist.git",
    svn_url: "https://github.com/bradtraversy/angular-crash-todolist",
    homepage: null,
    size: 112,
    stargazers_count: 220,
    watchers_count: 220,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 231,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 231,
    open_issues: 2,
    watchers: 220,
    default_branch: "master",
  },
  {
    id: 77139096,
    node_id: "MDEwOlJlcG9zaXRvcnk3NzEzOTA5Ng==",
    name: "angular60",
    full_name: "bradtraversy/angular60",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/angular60",
    description: "Angular in 60 minutes tutorial project",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/angular60",
    forks_url: "https://api.github.com/repos/bradtraversy/angular60/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/angular60/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/angular60/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/angular60/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/angular60/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/angular60/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/angular60/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/angular60/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/angular60/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/angular60/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/angular60/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/angular60/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/angular60/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/angular60/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/angular60/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/angular60/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/angular60/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/angular60/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/angular60/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/angular60/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/angular60/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/angular60/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/angular60/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/angular60/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/angular60/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/angular60/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/angular60/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/angular60/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/angular60/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/angular60/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/angular60/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/angular60/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/angular60/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/angular60/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/angular60/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/angular60/deployments",
    created_at: "2016-12-22T11:27:01Z",
    updated_at: "2021-09-21T07:25:36Z",
    pushed_at: "2017-03-17T11:58:42Z",
    git_url: "git://github.com/bradtraversy/angular60.git",
    ssh_url: "git@github.com:bradtraversy/angular60.git",
    clone_url: "https://github.com/bradtraversy/angular60.git",
    svn_url: "https://github.com/bradtraversy/angular60",
    homepage: null,
    size: 17,
    stargazers_count: 127,
    watchers_count: 127,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 102,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 102,
    open_issues: 3,
    watchers: 127,
    default_branch: "master",
  },
  {
    id: 108591272,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDg1OTEyNzI=",
    name: "angularfs",
    full_name: "bradtraversy/angularfs",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/angularfs",
    description: "Simple Angular and FireStore app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/angularfs",
    forks_url: "https://api.github.com/repos/bradtraversy/angularfs/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/angularfs/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/angularfs/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/angularfs/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/angularfs/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/angularfs/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/angularfs/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/angularfs/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/angularfs/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/angularfs/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/angularfs/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/angularfs/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/angularfs/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/angularfs/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/angularfs/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/angularfs/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/angularfs/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/angularfs/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/angularfs/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/angularfs/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/angularfs/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/angularfs/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/angularfs/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/angularfs/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/angularfs/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/angularfs/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/angularfs/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/angularfs/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/angularfs/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/angularfs/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/angularfs/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/angularfs/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/angularfs/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/angularfs/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/angularfs/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/angularfs/deployments",
    created_at: "2017-10-27T20:10:40Z",
    updated_at: "2021-09-20T15:22:50Z",
    pushed_at: "2017-11-19T03:59:55Z",
    git_url: "git://github.com/bradtraversy/angularfs.git",
    ssh_url: "git@github.com:bradtraversy/angularfs.git",
    clone_url: "https://github.com/bradtraversy/angularfs.git",
    svn_url: "https://github.com/bradtraversy/angularfs",
    homepage: null,
    size: 16,
    stargazers_count: 52,
    watchers_count: 52,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 40,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 40,
    open_issues: 5,
    watchers: 52,
    default_branch: "master",
  },
  {
    id: 102620609,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDI2MjA2MDk=",
    name: "animiesample",
    full_name: "bradtraversy/animiesample",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/animiesample",
    description:
      "Sample of an app built with the Anime JavaScript Animation engine",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/animiesample",
    forks_url: "https://api.github.com/repos/bradtraversy/animiesample/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/animiesample/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/animiesample/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/animiesample/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/animiesample/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/animiesample/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/animiesample/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/animiesample/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/animiesample/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/animiesample/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/animiesample/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/animiesample/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/animiesample/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/animiesample/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/animiesample/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/animiesample/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/animiesample/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/animiesample/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/animiesample/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/animiesample/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/animiesample/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/animiesample/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/animiesample/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/animiesample/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/animiesample/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/animiesample/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/animiesample/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/animiesample/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/animiesample/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/animiesample/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/animiesample/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/animiesample/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/animiesample/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/animiesample/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/animiesample/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/animiesample/deployments",
    created_at: "2017-09-06T14:43:51Z",
    updated_at: "2021-09-19T19:24:56Z",
    pushed_at: "2017-09-06T14:45:12Z",
    git_url: "git://github.com/bradtraversy/animiesample.git",
    ssh_url: "git@github.com:bradtraversy/animiesample.git",
    clone_url: "https://github.com/bradtraversy/animiesample.git",
    svn_url: "https://github.com/bradtraversy/animiesample",
    homepage: null,
    size: 1,
    stargazers_count: 16,
    watchers_count: 16,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 15,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 15,
    open_issues: 0,
    watchers: 16,
    default_branch: "master",
  },
  {
    id: 201106053,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDExMDYwNTM=",
    name: "apex-legends-tracker",
    full_name: "bradtraversy/apex-legends-tracker",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/apex-legends-tracker",
    description: "App to get Apex Legends stats",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/apex-legends-tracker",
    forks_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/apex-legends-tracker/deployments",
    created_at: "2019-08-07T18:27:01Z",
    updated_at: "2021-10-15T15:53:12Z",
    pushed_at: "2021-10-06T15:01:25Z",
    git_url: "git://github.com/bradtraversy/apex-legends-tracker.git",
    ssh_url: "git@github.com:bradtraversy/apex-legends-tracker.git",
    clone_url: "https://github.com/bradtraversy/apex-legends-tracker.git",
    svn_url: "https://github.com/bradtraversy/apex-legends-tracker",
    homepage: null,
    size: 1353,
    stargazers_count: 113,
    watchers_count: 113,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 18,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 18,
    open_issues: 3,
    watchers: 113,
    default_branch: "master",
  },
  {
    id: 100520910,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDA1MjA5MTA=",
    name: "articlebase",
    full_name: "bradtraversy/articlebase",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/articlebase",
    description: "Sails.js and mongodb article manager",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/articlebase",
    forks_url: "https://api.github.com/repos/bradtraversy/articlebase/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/articlebase/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/articlebase/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/articlebase/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/articlebase/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/articlebase/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/articlebase/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/articlebase/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/articlebase/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/articlebase/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/articlebase/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/articlebase/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/articlebase/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/articlebase/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/articlebase/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/articlebase/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/articlebase/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/articlebase/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/articlebase/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/articlebase/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/articlebase/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/articlebase/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/articlebase/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/articlebase/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/articlebase/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/articlebase/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/articlebase/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/articlebase/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/articlebase/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/articlebase/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/articlebase/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/articlebase/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/articlebase/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/articlebase/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/articlebase/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/articlebase/deployments",
    created_at: "2017-08-16T18:38:35Z",
    updated_at: "2021-09-19T19:24:57Z",
    pushed_at: "2019-11-02T16:40:34Z",
    git_url: "git://github.com/bradtraversy/articlebase.git",
    ssh_url: "git@github.com:bradtraversy/articlebase.git",
    clone_url: "https://github.com/bradtraversy/articlebase.git",
    svn_url: "https://github.com/bradtraversy/articlebase",
    homepage: null,
    size: 131,
    stargazers_count: 32,
    watchers_count: 32,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 22,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 22,
    open_issues: 0,
    watchers: 32,
    default_branch: "master",
  },
  {
    id: 112102058,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTIxMDIwNTg=",
    name: "aurelia_customer_manager",
    full_name: "bradtraversy/aurelia_customer_manager",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/aurelia_customer_manager",
    description: "Simple customer manager app using Aurelia and local storage",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/aurelia_customer_manager",
    forks_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/deployments",
    created_at: "2017-11-26T17:23:17Z",
    updated_at: "2021-09-19T19:24:57Z",
    pushed_at: "2017-11-26T17:24:51Z",
    git_url: "git://github.com/bradtraversy/aurelia_customer_manager.git",
    ssh_url: "git@github.com:bradtraversy/aurelia_customer_manager.git",
    clone_url: "https://github.com/bradtraversy/aurelia_customer_manager.git",
    svn_url: "https://github.com/bradtraversy/aurelia_customer_manager",
    homepage: null,
    size: 666,
    stargazers_count: 7,
    watchers_count: 7,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 5,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 5,
    open_issues: 0,
    watchers: 7,
    default_branch: "master",
  },
  {
    id: 217535155,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTc1MzUxNTU=",
    name: "axios-crash",
    full_name: "bradtraversy/axios-crash",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/axios-crash",
    description: "Axios crash course files",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/axios-crash",
    forks_url: "https://api.github.com/repos/bradtraversy/axios-crash/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/axios-crash/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/axios-crash/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/axios-crash/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/axios-crash/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/axios-crash/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/axios-crash/deployments",
    created_at: "2019-10-25T13:04:36Z",
    updated_at: "2021-10-24T13:36:28Z",
    pushed_at: "2019-10-25T13:06:47Z",
    git_url: "git://github.com/bradtraversy/axios-crash.git",
    ssh_url: "git@github.com:bradtraversy/axios-crash.git",
    clone_url: "https://github.com/bradtraversy/axios-crash.git",
    svn_url: "https://github.com/bradtraversy/axios-crash",
    homepage: null,
    size: 3,
    stargazers_count: 211,
    watchers_count: 211,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 253,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 253,
    open_issues: 0,
    watchers: 211,
    default_branch: "master",
  },
  {
    id: 112221349,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTIyMjEzNDk=",
    name: "babel_webpack_starter",
    full_name: "bradtraversy/babel_webpack_starter",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/babel_webpack_starter",
    description: "Starter pack for ES6+ applications using Webpack and Babel",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/babel_webpack_starter",
    forks_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/babel_webpack_starter/deployments",
    created_at: "2017-11-27T16:37:39Z",
    updated_at: "2021-10-25T21:56:53Z",
    pushed_at: "2021-10-05T19:34:33Z",
    git_url: "git://github.com/bradtraversy/babel_webpack_starter.git",
    ssh_url: "git@github.com:bradtraversy/babel_webpack_starter.git",
    clone_url: "https://github.com/bradtraversy/babel_webpack_starter.git",
    svn_url: "https://github.com/bradtraversy/babel_webpack_starter",
    homepage: null,
    size: 754,
    stargazers_count: 300,
    watchers_count: 300,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 165,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 12,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 165,
    open_issues: 12,
    watchers: 300,
    default_branch: "master",
  },
  {
    id: 47503742,
    node_id: "MDEwOlJlcG9zaXRvcnk0NzUwMzc0Mg==",
    name: "barchart",
    full_name: "bradtraversy/barchart",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/barchart",
    description: "A simple bar chart created with the D3 JavaScript library",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/barchart",
    forks_url: "https://api.github.com/repos/bradtraversy/barchart/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/barchart/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/barchart/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/barchart/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/barchart/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/barchart/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/barchart/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/barchart/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/barchart/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/barchart/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/barchart/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/barchart/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/barchart/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/barchart/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/barchart/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/barchart/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/barchart/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/barchart/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/barchart/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/barchart/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/barchart/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/barchart/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/barchart/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/barchart/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/barchart/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/barchart/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/barchart/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/barchart/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/barchart/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/barchart/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/barchart/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/barchart/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/barchart/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/barchart/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/barchart/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/barchart/deployments",
    created_at: "2015-12-06T16:09:32Z",
    updated_at: "2021-09-19T19:25:00Z",
    pushed_at: "2015-12-06T16:12:35Z",
    git_url: "git://github.com/bradtraversy/barchart.git",
    ssh_url: "git@github.com:bradtraversy/barchart.git",
    clone_url: "https://github.com/bradtraversy/barchart.git",
    svn_url: "https://github.com/bradtraversy/barchart",
    homepage: null,
    size: 1,
    stargazers_count: 10,
    watchers_count: 10,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 9,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 9,
    open_issues: 0,
    watchers: 10,
    default_branch: "master",
  },
  {
    id: 35898671,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTg5ODY3MQ==",
    name: "basicphonegap",
    full_name: "bradtraversy/basicphonegap",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/basicphonegap",
    description: "Very simple company mobile app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/basicphonegap",
    forks_url: "https://api.github.com/repos/bradtraversy/basicphonegap/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/basicphonegap/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/basicphonegap/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/basicphonegap/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/basicphonegap/deployments",
    created_at: "2015-05-19T17:49:38Z",
    updated_at: "2021-09-19T19:25:01Z",
    pushed_at: "2015-05-19T17:52:40Z",
    git_url: "git://github.com/bradtraversy/basicphonegap.git",
    ssh_url: "git@github.com:bradtraversy/basicphonegap.git",
    clone_url: "https://github.com/bradtraversy/basicphonegap.git",
    svn_url: "https://github.com/bradtraversy/basicphonegap",
    homepage: null,
    size: 1680,
    stargazers_count: 5,
    watchers_count: 5,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 5,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 5,
    open_issues: 0,
    watchers: 5,
    default_branch: "master",
  },
  {
    id: 118180142,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTgxODAxNDI=",
    name: "bitzprice",
    full_name: "bradtraversy/bitzprice",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bitzprice",
    description: "React Next.js app to show current Bitcoin price",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bitzprice",
    forks_url: "https://api.github.com/repos/bradtraversy/bitzprice/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bitzprice/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bitzprice/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/bitzprice/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bitzprice/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/bitzprice/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bitzprice/deployments",
    created_at: "2018-01-19T21:24:27Z",
    updated_at: "2021-09-19T19:25:01Z",
    pushed_at: "2018-07-19T11:25:49Z",
    git_url: "git://github.com/bradtraversy/bitzprice.git",
    ssh_url: "git@github.com:bradtraversy/bitzprice.git",
    clone_url: "https://github.com/bradtraversy/bitzprice.git",
    svn_url: "https://github.com/bradtraversy/bitzprice",
    homepage: null,
    size: 53,
    stargazers_count: 105,
    watchers_count: 105,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 64,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 64,
    open_issues: 0,
    watchers: 105,
    default_branch: "master",
  },
  {
    id: 74058128,
    node_id: "MDEwOlJlcG9zaXRvcnk3NDA1ODEyOA==",
    name: "bizlight_theme",
    full_name: "bradtraversy/bizlight_theme",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bizlight_theme",
    description: "Custom Twitter Bootstrap theme that uses bootstrap-sass",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bizlight_theme",
    forks_url: "https://api.github.com/repos/bradtraversy/bizlight_theme/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bizlight_theme/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bizlight_theme/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bizlight_theme/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bizlight_theme/deployments",
    created_at: "2016-11-17T19:03:32Z",
    updated_at: "2021-09-20T15:23:23Z",
    pushed_at: "2016-11-17T19:04:10Z",
    git_url: "git://github.com/bradtraversy/bizlight_theme.git",
    ssh_url: "git@github.com:bradtraversy/bizlight_theme.git",
    clone_url: "https://github.com/bradtraversy/bizlight_theme.git",
    svn_url: "https://github.com/bradtraversy/bizlight_theme",
    homepage: null,
    size: 1607,
    stargazers_count: 39,
    watchers_count: 39,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 19,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 19,
    open_issues: 1,
    watchers: 39,
    default_branch: "master",
  },
  {
    id: 78652799,
    node_id: "MDEwOlJlcG9zaXRvcnk3ODY1Mjc5OQ==",
    name: "bookmarker",
    full_name: "bradtraversy/bookmarker",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bookmarker",
    description: "Website bookmarker app built with pure JavaScript",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bookmarker",
    forks_url: "https://api.github.com/repos/bradtraversy/bookmarker/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bookmarker/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bookmarker/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/bookmarker/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bookmarker/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/bookmarker/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bookmarker/deployments",
    created_at: "2017-01-11T15:36:43Z",
    updated_at: "2021-11-02T14:02:59Z",
    pushed_at: "2019-01-09T13:05:43Z",
    git_url: "git://github.com/bradtraversy/bookmarker.git",
    ssh_url: "git@github.com:bradtraversy/bookmarker.git",
    clone_url: "https://github.com/bradtraversy/bookmarker.git",
    svn_url: "https://github.com/bradtraversy/bookmarker",
    homepage: null,
    size: 144,
    stargazers_count: 145,
    watchers_count: 145,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 115,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 115,
    open_issues: 4,
    watchers: 145,
    default_branch: "master",
  },
  {
    id: 43564124,
    node_id: "MDEwOlJlcG9zaXRvcnk0MzU2NDEyNA==",
    name: "bookstore",
    full_name: "bradtraversy/bookstore",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bookstore",
    description: "Simple RESTful JSON api using Nodejs, Express and MongoDB",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bookstore",
    forks_url: "https://api.github.com/repos/bradtraversy/bookstore/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bookstore/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bookstore/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bookstore/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bookstore/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bookstore/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/bookstore/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bookstore/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bookstore/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bookstore/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bookstore/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bookstore/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bookstore/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bookstore/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bookstore/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bookstore/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bookstore/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bookstore/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bookstore/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bookstore/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bookstore/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bookstore/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bookstore/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bookstore/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bookstore/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bookstore/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/bookstore/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bookstore/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bookstore/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bookstore/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bookstore/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bookstore/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bookstore/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bookstore/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bookstore/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bookstore/deployments",
    created_at: "2015-10-02T16:34:56Z",
    updated_at: "2021-10-04T07:29:26Z",
    pushed_at: "2019-04-03T12:56:54Z",
    git_url: "git://github.com/bradtraversy/bookstore.git",
    ssh_url: "git@github.com:bradtraversy/bookstore.git",
    clone_url: "https://github.com/bradtraversy/bookstore.git",
    svn_url: "https://github.com/bradtraversy/bookstore",
    homepage: null,
    size: 2667,
    stargazers_count: 222,
    watchers_count: 222,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 210,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 210,
    open_issues: 6,
    watchers: 222,
    default_branch: "master",
  },
  {
    id: 25117907,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTExNzkwNw==",
    name: "bootsassy",
    full_name: "bradtraversy/bootsassy",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bootsassy",
    description:
      "Bootsassy is an HTML5/CSS framework that sits on top of Bootstrap. Use the .scss files to customize further than the basic Bootstrap styles.",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bootsassy",
    forks_url: "https://api.github.com/repos/bradtraversy/bootsassy/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bootsassy/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bootsassy/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/bootsassy/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bootsassy/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/bootsassy/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bootsassy/deployments",
    created_at: "2014-10-12T11:50:26Z",
    updated_at: "2021-09-19T19:25:04Z",
    pushed_at: "2014-10-14T20:25:14Z",
    git_url: "git://github.com/bradtraversy/bootsassy.git",
    ssh_url: "git@github.com:bradtraversy/bootsassy.git",
    clone_url: "https://github.com/bradtraversy/bootsassy.git",
    svn_url: "https://github.com/bradtraversy/bootsassy",
    homepage: null,
    size: 3528,
    stargazers_count: 4,
    watchers_count: 4,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "gpl-2.0",
      name: "GNU General Public License v2.0",
      spdx_id: "GPL-2.0",
      url: "https://api.github.com/licenses/gpl-2.0",
      node_id: "MDc6TGljZW5zZTg=",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 3,
    open_issues: 1,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 375092400,
    node_id: "MDEwOlJlcG9zaXRvcnkzNzUwOTI0MDA=",
    name: "bootstrap-bootcamp-website",
    full_name: "bradtraversy/bootstrap-bootcamp-website",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bootstrap-bootcamp-website",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website",
    forks_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/deployments",
    created_at: "2021-06-08T17:30:00Z",
    updated_at: "2021-11-03T19:19:16Z",
    pushed_at: "2021-10-01T00:25:50Z",
    git_url: "git://github.com/bradtraversy/bootstrap-bootcamp-website.git",
    ssh_url: "git@github.com:bradtraversy/bootstrap-bootcamp-website.git",
    clone_url: "https://github.com/bradtraversy/bootstrap-bootcamp-website.git",
    svn_url: "https://github.com/bradtraversy/bootstrap-bootcamp-website",
    homepage: null,
    size: 31,
    stargazers_count: 209,
    watchers_count: 209,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 150,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 150,
    open_issues: 2,
    watchers: 209,
    default_branch: "main",
  },
  {
    id: 146318874,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDYzMTg4NzQ=",
    name: "brainjs_examples",
    full_name: "bradtraversy/brainjs_examples",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/brainjs_examples",
    description: "Some examples of simple machine learning using Brain.js",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/brainjs_examples",
    forks_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/brainjs_examples/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/brainjs_examples/deployments",
    created_at: "2018-08-27T15:42:06Z",
    updated_at: "2021-10-30T12:30:47Z",
    pushed_at: "2018-10-21T13:26:11Z",
    git_url: "git://github.com/bradtraversy/brainjs_examples.git",
    ssh_url: "git@github.com:bradtraversy/brainjs_examples.git",
    clone_url: "https://github.com/bradtraversy/brainjs_examples.git",
    svn_url: "https://github.com/bradtraversy/brainjs_examples",
    homepage: null,
    size: 9,
    stargazers_count: 89,
    watchers_count: 89,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 54,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 54,
    open_issues: 1,
    watchers: 89,
    default_branch: "master",
  },
  {
    id: 276689002,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzY2ODkwMDI=",
    name: "breaking-bad-cast",
    full_name: "bradtraversy/breaking-bad-cast",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/breaking-bad-cast",
    description: "App to show cast info for breaking bad",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/breaking-bad-cast",
    forks_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/breaking-bad-cast/deployments",
    created_at: "2020-07-02T15:58:09Z",
    updated_at: "2021-11-03T22:40:40Z",
    pushed_at: "2021-01-07T21:31:29Z",
    git_url: "git://github.com/bradtraversy/breaking-bad-cast.git",
    ssh_url: "git@github.com:bradtraversy/breaking-bad-cast.git",
    clone_url: "https://github.com/bradtraversy/breaking-bad-cast.git",
    svn_url: "https://github.com/bradtraversy/breaking-bad-cast",
    homepage: null,
    size: 418,
    stargazers_count: 197,
    watchers_count: 197,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 139,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 139,
    open_issues: 2,
    watchers: 197,
    default_branch: "master",
  },
  {
    id: 241138902,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDExMzg5MDI=",
    name: "breakout_desktop_nw",
    full_name: "bradtraversy/breakout_desktop_nw",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/breakout_desktop_nw",
    description: "Desktop version of Breakout!",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/breakout_desktop_nw",
    forks_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/deployments",
    created_at: "2020-02-17T15:16:39Z",
    updated_at: "2021-10-14T01:28:12Z",
    pushed_at: "2021-05-11T03:33:47Z",
    git_url: "git://github.com/bradtraversy/breakout_desktop_nw.git",
    ssh_url: "git@github.com:bradtraversy/breakout_desktop_nw.git",
    clone_url: "https://github.com/bradtraversy/breakout_desktop_nw.git",
    svn_url: "https://github.com/bradtraversy/breakout_desktop_nw",
    homepage: null,
    size: 125,
    stargazers_count: 74,
    watchers_count: 74,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 24,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 24,
    open_issues: 5,
    watchers: 74,
    default_branch: "master",
  },
  {
    id: 150337525,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTAzMzc1MjU=",
    name: "bs4-sass-starter",
    full_name: "bradtraversy/bs4-sass-starter",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bs4-sass-starter",
    description: "Starter pack to use Bootstrap 4 and Sass",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bs4-sass-starter",
    forks_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bs4-sass-starter/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bs4-sass-starter/deployments",
    created_at: "2018-09-25T22:38:02Z",
    updated_at: "2021-09-20T15:23:21Z",
    pushed_at: "2018-09-25T23:33:13Z",
    git_url: "git://github.com/bradtraversy/bs4-sass-starter.git",
    ssh_url: "git@github.com:bradtraversy/bs4-sass-starter.git",
    clone_url: "https://github.com/bradtraversy/bs4-sass-starter.git",
    svn_url: "https://github.com/bradtraversy/bs4-sass-starter",
    homepage: null,
    size: 1326,
    stargazers_count: 42,
    watchers_count: 42,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 13,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 13,
    open_issues: 0,
    watchers: 42,
    default_branch: "master",
  },
  {
    id: 101219347,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDEyMTkzNDc=",
    name: "bs4starter",
    full_name: "bradtraversy/bs4starter",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bs4starter",
    description: "Starter pack for Bootstrap 4 Beta",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bs4starter",
    forks_url: "https://api.github.com/repos/bradtraversy/bs4starter/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/bs4starter/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/bs4starter/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/bs4starter/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/bs4starter/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/bs4starter/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bs4starter/deployments",
    created_at: "2017-08-23T19:53:31Z",
    updated_at: "2021-10-20T00:13:54Z",
    pushed_at: "2020-09-01T12:51:52Z",
    git_url: "git://github.com/bradtraversy/bs4starter.git",
    ssh_url: "git@github.com:bradtraversy/bs4starter.git",
    clone_url: "https://github.com/bradtraversy/bs4starter.git",
    svn_url: "https://github.com/bradtraversy/bs4starter",
    homepage: null,
    size: 5,
    stargazers_count: 178,
    watchers_count: 178,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 151,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 151,
    open_issues: 5,
    watchers: 178,
    default_branch: "master",
  },
  {
    id: 99012124,
    node_id: "MDEwOlJlcG9zaXRvcnk5OTAxMjEyNA==",
    name: "bs4starter_alpha6",
    full_name: "bradtraversy/bs4starter_alpha6",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bs4starter_alpha6",
    description: "Bootstrap 4 starter pack with Gulp and Sass",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bs4starter_alpha6",
    forks_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bs4starter_alpha6/deployments",
    created_at: "2017-08-01T14:47:54Z",
    updated_at: "2021-09-17T09:16:20Z",
    pushed_at: "2017-08-15T10:25:18Z",
    git_url: "git://github.com/bradtraversy/bs4starter_alpha6.git",
    ssh_url: "git@github.com:bradtraversy/bs4starter_alpha6.git",
    clone_url: "https://github.com/bradtraversy/bs4starter_alpha6.git",
    svn_url: "https://github.com/bradtraversy/bs4starter_alpha6",
    homepage: null,
    size: 52,
    stargazers_count: 29,
    watchers_count: 29,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 23,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 23,
    open_issues: 2,
    watchers: 29,
    default_branch: "master",
  },
  {
    id: 81083935,
    node_id: "MDEwOlJlcG9zaXRvcnk4MTA4MzkzNQ==",
    name: "bthosting_foundation",
    full_name: "bradtraversy/bthosting_foundation",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/bthosting_foundation",
    description: "Foundation hosting template using Foundation-cli & Sass",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/bthosting_foundation",
    forks_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/bthosting_foundation/deployments",
    created_at: "2017-02-06T12:15:46Z",
    updated_at: "2021-09-19T19:25:12Z",
    pushed_at: "2017-02-06T12:19:25Z",
    git_url: "git://github.com/bradtraversy/bthosting_foundation.git",
    ssh_url: "git@github.com:bradtraversy/bthosting_foundation.git",
    clone_url: "https://github.com/bradtraversy/bthosting_foundation.git",
    svn_url: "https://github.com/bradtraversy/bthosting_foundation",
    homepage: null,
    size: 1040,
    stargazers_count: 30,
    watchers_count: 30,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 24,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 24,
    open_issues: 1,
    watchers: 30,
    default_branch: "master",
  },
  {
    id: 151088595,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTEwODg1OTU=",
    name: "btre_project",
    full_name: "bradtraversy/btre_project",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/btre_project",
    description: "Django real estate website",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/btre_project",
    forks_url: "https://api.github.com/repos/bradtraversy/btre_project/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/btre_project/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/btre_project/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/btre_project/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/btre_project/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/btre_project/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/btre_project/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/btre_project/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/btre_project/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/btre_project/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/btre_project/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/btre_project/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/btre_project/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/btre_project/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/btre_project/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/btre_project/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/btre_project/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/btre_project/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/btre_project/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/btre_project/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/btre_project/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/btre_project/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/btre_project/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/btre_project/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/btre_project/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/btre_project/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/btre_project/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/btre_project/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/btre_project/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/btre_project/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/btre_project/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/btre_project/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/btre_project/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/btre_project/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/btre_project/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/btre_project/deployments",
    created_at: "2018-10-01T12:54:54Z",
    updated_at: "2021-11-03T03:40:16Z",
    pushed_at: "2021-09-08T00:36:54Z",
    git_url: "git://github.com/bradtraversy/btre_project.git",
    ssh_url: "git@github.com:bradtraversy/btre_project.git",
    clone_url: "https://github.com/bradtraversy/btre_project.git",
    svn_url: "https://github.com/bradtraversy/btre_project",
    homepage: null,
    size: 2460,
    stargazers_count: 405,
    watchers_count: 405,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 274,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 13,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 274,
    open_issues: 13,
    watchers: 405,
    default_branch: "master",
  },
  {
    id: 104204907,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDQyMDQ5MDc=",
    name: "casablanca-tutsplus",
    full_name: "bradtraversy/casablanca-tutsplus",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/casablanca-tutsplus",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/bradtraversy/casablanca-tutsplus",
    forks_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/casablanca-tutsplus/deployments",
    created_at: "2017-09-20T11:07:02Z",
    updated_at: "2021-09-19T19:25:13Z",
    pushed_at: "2016-12-23T14:39:39Z",
    git_url: "git://github.com/bradtraversy/casablanca-tutsplus.git",
    ssh_url: "git@github.com:bradtraversy/casablanca-tutsplus.git",
    clone_url: "https://github.com/bradtraversy/casablanca-tutsplus.git",
    svn_url: "https://github.com/bradtraversy/casablanca-tutsplus",
    homepage: null,
    size: 5704,
    stargazers_count: 4,
    watchers_count: 4,
    language: "HTML",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 3,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 249532210,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDk1MzIyMTA=",
    name: "chatcord",
    full_name: "bradtraversy/chatcord",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/chatcord",
    description: "Realtime chat app with rooms",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/chatcord",
    forks_url: "https://api.github.com/repos/bradtraversy/chatcord/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/chatcord/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/chatcord/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/chatcord/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/chatcord/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/chatcord/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/chatcord/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/chatcord/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/chatcord/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/chatcord/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/chatcord/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/chatcord/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/chatcord/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/chatcord/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/chatcord/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/chatcord/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/chatcord/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/chatcord/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/chatcord/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/chatcord/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/chatcord/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/chatcord/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/chatcord/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/chatcord/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/chatcord/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/chatcord/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/chatcord/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/chatcord/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/chatcord/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/chatcord/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/chatcord/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/chatcord/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/chatcord/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/chatcord/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/chatcord/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/chatcord/deployments",
    created_at: "2020-03-23T20:04:23Z",
    updated_at: "2021-11-04T02:33:05Z",
    pushed_at: "2021-06-03T15:37:41Z",
    git_url: "git://github.com/bradtraversy/chatcord.git",
    ssh_url: "git@github.com:bradtraversy/chatcord.git",
    clone_url: "https://github.com/bradtraversy/chatcord.git",
    svn_url: "https://github.com/bradtraversy/chatcord",
    homepage: null,
    size: 69,
    stargazers_count: 802,
    watchers_count: 802,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 818,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 19,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 818,
    open_issues: 19,
    watchers: 802,
    default_branch: "master",
  },
  {
    id: 72761451,
    node_id: "MDEwOlJlcG9zaXRvcnk3Mjc2MTQ1MQ==",
    name: "ciblog",
    full_name: "bradtraversy/ciblog",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/ciblog",
    description: "Simple blog built on Codeigniter",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/ciblog",
    forks_url: "https://api.github.com/repos/bradtraversy/ciblog/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/ciblog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/ciblog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/ciblog/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/ciblog/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/ciblog/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/ciblog/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/ciblog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/ciblog/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/ciblog/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/ciblog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/ciblog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/ciblog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/ciblog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/ciblog/statuses/{sha}",
    languages_url: "https://api.github.com/repos/bradtraversy/ciblog/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/ciblog/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/ciblog/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/ciblog/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/ciblog/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/ciblog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/ciblog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/ciblog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/ciblog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/ciblog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/ciblog/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/ciblog/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/ciblog/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/bradtraversy/ciblog/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/ciblog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/ciblog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/ciblog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/ciblog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/ciblog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/ciblog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/ciblog/deployments",
    created_at: "2016-11-03T15:51:27Z",
    updated_at: "2021-09-23T19:50:21Z",
    pushed_at: "2021-07-22T17:11:57Z",
    git_url: "git://github.com/bradtraversy/ciblog.git",
    ssh_url: "git@github.com:bradtraversy/ciblog.git",
    clone_url: "https://github.com/bradtraversy/ciblog.git",
    svn_url: "https://github.com/bradtraversy/ciblog",
    homepage: null,
    size: 559,
    stargazers_count: 178,
    watchers_count: 178,
    language: "PHP",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 166,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 11,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 166,
    open_issues: 11,
    watchers: 178,
    default_branch: "master",
  },
  {
    id: 142042896,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDIwNDI4OTY=",
    name: "clientpanel_react",
    full_name: "bradtraversy/clientpanel_react",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/clientpanel_react",
    description: " Client management tool built on React, Redux and Firebase",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/clientpanel_react",
    forks_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/clientpanel_react/deployments",
    created_at: "2018-07-23T16:51:36Z",
    updated_at: "2021-09-23T15:49:22Z",
    pushed_at: "2021-09-20T23:16:55Z",
    git_url: "git://github.com/bradtraversy/clientpanel_react.git",
    ssh_url: "git@github.com:bradtraversy/clientpanel_react.git",
    clone_url: "https://github.com/bradtraversy/clientpanel_react.git",
    svn_url: "https://github.com/bradtraversy/clientpanel_react",
    homepage: null,
    size: 3322,
    stargazers_count: 62,
    watchers_count: 62,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 21,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 16,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 21,
    open_issues: 16,
    watchers: 62,
    default_branch: "master",
  },
  {
    id: 161517238,
    node_id: "MDEwOlJlcG9zaXRvcnkxNjE1MTcyMzg=",
    name: "codegig",
    full_name: "bradtraversy/codegig",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/codegig",
    description: "Simple job find app for coders",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/codegig",
    forks_url: "https://api.github.com/repos/bradtraversy/codegig/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/codegig/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/codegig/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/codegig/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/codegig/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/codegig/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/codegig/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/codegig/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/codegig/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/codegig/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/codegig/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/codegig/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/codegig/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/codegig/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/codegig/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/codegig/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/codegig/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/codegig/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/codegig/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/codegig/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/codegig/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/codegig/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/codegig/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/codegig/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/codegig/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/codegig/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/codegig/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/codegig/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/codegig/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/codegig/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/codegig/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/codegig/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/codegig/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/codegig/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/codegig/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/codegig/deployments",
    created_at: "2018-12-12T16:44:09Z",
    updated_at: "2021-11-02T04:31:25Z",
    pushed_at: "2021-05-07T23:09:46Z",
    git_url: "git://github.com/bradtraversy/codegig.git",
    ssh_url: "git@github.com:bradtraversy/codegig.git",
    clone_url: "https://github.com/bradtraversy/codegig.git",
    svn_url: "https://github.com/bradtraversy/codegig",
    homepage: null,
    size: 329,
    stargazers_count: 164,
    watchers_count: 164,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 83,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 7,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 83,
    open_issues: 7,
    watchers: 164,
    default_branch: "master",
  },
  {
    id: 252799979,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTI3OTk5Nzk=",
    name: "coindex-cli",
    full_name: "bradtraversy/coindex-cli",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/coindex-cli",
    description: "Node.js CLI for checking crypto prices",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/coindex-cli",
    forks_url: "https://api.github.com/repos/bradtraversy/coindex-cli/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/coindex-cli/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/coindex-cli/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/coindex-cli/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/coindex-cli/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/coindex-cli/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/coindex-cli/deployments",
    created_at: "2020-04-03T17:41:38Z",
    updated_at: "2021-10-07T16:48:01Z",
    pushed_at: "2021-05-11T09:19:02Z",
    git_url: "git://github.com/bradtraversy/coindex-cli.git",
    ssh_url: "git@github.com:bradtraversy/coindex-cli.git",
    clone_url: "https://github.com/bradtraversy/coindex-cli.git",
    svn_url: "https://github.com/bradtraversy/coindex-cli",
    homepage: null,
    size: 24,
    stargazers_count: 65,
    watchers_count: 65,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 18,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 18,
    open_issues: 4,
    watchers: 65,
    default_branch: "master",
  },
  {
    id: 189278733,
    node_id: "MDEwOlJlcG9zaXRvcnkxODkyNzg3MzM=",
    name: "contact-keeper",
    full_name: "bradtraversy/contact-keeper",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/contact-keeper",
    description: "Contact manager using React hooks & context",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/contact-keeper",
    forks_url: "https://api.github.com/repos/bradtraversy/contact-keeper/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/contact-keeper/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/contact-keeper/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/contact-keeper/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/contact-keeper/deployments",
    created_at: "2019-05-29T18:31:48Z",
    updated_at: "2021-10-22T20:59:00Z",
    pushed_at: "2021-10-05T22:03:58Z",
    git_url: "git://github.com/bradtraversy/contact-keeper.git",
    ssh_url: "git@github.com:bradtraversy/contact-keeper.git",
    clone_url: "https://github.com/bradtraversy/contact-keeper.git",
    svn_url: "https://github.com/bradtraversy/contact-keeper",
    homepage: null,
    size: 3094,
    stargazers_count: 289,
    watchers_count: 289,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 190,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 9,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 190,
    open_issues: 9,
    watchers: 289,
    default_branch: "master",
  },
  {
    id: 188501475,
    node_id: "MDEwOlJlcG9zaXRvcnkxODg1MDE0NzU=",
    name: "contact_keeper_api",
    full_name: "bradtraversy/contact_keeper_api",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/contact_keeper_api",
    description: "REST API with JWT for React course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/contact_keeper_api",
    forks_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/contact_keeper_api/deployments",
    created_at: "2019-05-25T00:11:57Z",
    updated_at: "2021-10-12T00:19:23Z",
    pushed_at: "2021-08-11T01:10:54Z",
    git_url: "git://github.com/bradtraversy/contact_keeper_api.git",
    ssh_url: "git@github.com:bradtraversy/contact_keeper_api.git",
    clone_url: "https://github.com/bradtraversy/contact_keeper_api.git",
    svn_url: "https://github.com/bradtraversy/contact_keeper_api",
    homepage: null,
    size: 435,
    stargazers_count: 139,
    watchers_count: 139,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 45,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 10,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 45,
    open_issues: 10,
    watchers: 139,
    default_branch: "master",
  },
  {
    id: 348336303,
    node_id: "MDEwOlJlcG9zaXRvcnkzNDgzMzYzMDM=",
    name: "creative-agency-website",
    full_name: "bradtraversy/creative-agency-website",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/creative-agency-website",
    description: "Agency website - basic HTML/CSS",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/creative-agency-website",
    forks_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/creative-agency-website/deployments",
    created_at: "2021-03-16T12:19:23Z",
    updated_at: "2021-11-03T19:18:59Z",
    pushed_at: "2021-03-16T17:02:01Z",
    git_url: "git://github.com/bradtraversy/creative-agency-website.git",
    ssh_url: "git@github.com:bradtraversy/creative-agency-website.git",
    clone_url: "https://github.com/bradtraversy/creative-agency-website.git",
    svn_url: "https://github.com/bradtraversy/creative-agency-website",
    homepage: null,
    size: 4057,
    stargazers_count: 198,
    watchers_count: 198,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 98,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 98,
    open_issues: 0,
    watchers: 198,
    default_branch: "master",
  },
  {
    id: 110571894,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTA1NzE4OTQ=",
    name: "customer-cli",
    full_name: "bradtraversy/customer-cli",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/customer-cli",
    description: "Customer management CLI built with Node and MongoDB",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/customer-cli",
    forks_url: "https://api.github.com/repos/bradtraversy/customer-cli/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/customer-cli/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/customer-cli/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/customer-cli/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/customer-cli/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/customer-cli/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/customer-cli/deployments",
    created_at: "2017-11-13T16:21:50Z",
    updated_at: "2021-09-23T15:49:21Z",
    pushed_at: "2021-07-01T15:00:55Z",
    git_url: "git://github.com/bradtraversy/customer-cli.git",
    ssh_url: "git@github.com:bradtraversy/customer-cli.git",
    clone_url: "https://github.com/bradtraversy/customer-cli.git",
    svn_url: "https://github.com/bradtraversy/customer-cli",
    homepage: null,
    size: 4,
    stargazers_count: 68,
    watchers_count: 68,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 28,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 28,
    open_issues: 4,
    watchers: 68,
    default_branch: "master",
  },
  {
    id: 98894016,
    node_id: "MDEwOlJlcG9zaXRvcnk5ODg5NDAxNg==",
    name: "customerbase",
    full_name: "bradtraversy/customerbase",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/customerbase",
    description: "GraphQL server using Express and JSON-Server",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/customerbase",
    forks_url: "https://api.github.com/repos/bradtraversy/customerbase/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/customerbase/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/customerbase/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/customerbase/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/customerbase/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/customerbase/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/customerbase/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/customerbase/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/customerbase/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/customerbase/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/customerbase/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/customerbase/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/customerbase/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/customerbase/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/customerbase/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/customerbase/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/customerbase/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/customerbase/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/customerbase/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/customerbase/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/customerbase/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/customerbase/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/customerbase/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/customerbase/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/customerbase/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/customerbase/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/customerbase/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/customerbase/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/customerbase/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/customerbase/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/customerbase/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/customerbase/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/customerbase/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/customerbase/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/customerbase/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/customerbase/deployments",
    created_at: "2017-07-31T13:54:18Z",
    updated_at: "2021-10-10T08:48:10Z",
    pushed_at: "2020-09-03T16:08:44Z",
    git_url: "git://github.com/bradtraversy/customerbase.git",
    ssh_url: "git@github.com:bradtraversy/customerbase.git",
    clone_url: "https://github.com/bradtraversy/customerbase.git",
    svn_url: "https://github.com/bradtraversy/customerbase",
    homepage: null,
    size: 4,
    stargazers_count: 87,
    watchers_count: 87,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 61,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 61,
    open_issues: 3,
    watchers: 87,
    default_branch: "master",
  },
  {
    id: 265334890,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjUzMzQ4OTA=",
    name: "deno-rest-api",
    full_name: "bradtraversy/deno-rest-api",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/deno-rest-api",
    description: "Simple REST API using Deno and Oak",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/deno-rest-api",
    forks_url: "https://api.github.com/repos/bradtraversy/deno-rest-api/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/deno-rest-api/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/deno-rest-api/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/deno-rest-api/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/deno-rest-api/deployments",
    created_at: "2020-05-19T18:48:23Z",
    updated_at: "2021-10-13T04:12:52Z",
    pushed_at: "2021-05-21T01:14:09Z",
    git_url: "git://github.com/bradtraversy/deno-rest-api.git",
    ssh_url: "git@github.com:bradtraversy/deno-rest-api.git",
    clone_url: "https://github.com/bradtraversy/deno-rest-api.git",
    svn_url: "https://github.com/bradtraversy/deno-rest-api",
    homepage: null,
    size: 7,
    stargazers_count: 258,
    watchers_count: 258,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 72,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 72,
    open_issues: 3,
    watchers: 258,
    default_branch: "master",
  },
  {
    id: 261787758,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjE3ODc3NTg=",
    name: "design-resources-for-developers",
    full_name: "bradtraversy/design-resources-for-developers",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/design-resources-for-developers",
    description:
      "Curated list of design and UI resources from stock photos, web templates, CSS frameworks, UI libraries, tools and much more",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/design-resources-for-developers",
    forks_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/design-resources-for-developers/deployments",
    created_at: "2020-05-06T14:40:35Z",
    updated_at: "2021-11-04T07:59:47Z",
    pushed_at: "2021-11-03T11:45:32Z",
    git_url:
      "git://github.com/bradtraversy/design-resources-for-developers.git",
    ssh_url: "git@github.com:bradtraversy/design-resources-for-developers.git",
    clone_url:
      "https://github.com/bradtraversy/design-resources-for-developers.git",
    svn_url: "https://github.com/bradtraversy/design-resources-for-developers",
    homepage: null,
    size: 4851,
    stargazers_count: 33078,
    watchers_count: 33078,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 7573,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 7573,
    open_issues: 0,
    watchers: 33078,
    default_branch: "master",
  },
  {
    id: 214818446,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTQ4MTg0NDY=",
    name: "devcamper-api",
    full_name: "bradtraversy/devcamper-api",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/devcamper-api",
    description: "Backend for devcamper app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/devcamper-api",
    forks_url: "https://api.github.com/repos/bradtraversy/devcamper-api/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/devcamper-api/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/devcamper-api/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/devcamper-api/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/devcamper-api/deployments",
    created_at: "2019-10-13T12:45:09Z",
    updated_at: "2021-10-29T10:23:26Z",
    pushed_at: "2021-09-29T06:10:09Z",
    git_url: "git://github.com/bradtraversy/devcamper-api.git",
    ssh_url: "git@github.com:bradtraversy/devcamper-api.git",
    clone_url: "https://github.com/bradtraversy/devcamper-api.git",
    svn_url: "https://github.com/bradtraversy/devcamper-api",
    homepage: null,
    size: 480,
    stargazers_count: 364,
    watchers_count: 364,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 302,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 26,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 302,
    open_issues: 26,
    watchers: 364,
    default_branch: "master",
  },
  {
    id: 183677633,
    node_id: "MDEwOlJlcG9zaXRvcnkxODM2Nzc2MzM=",
    name: "devconnector_2.0",
    full_name: "bradtraversy/devconnector_2.0",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/devconnector_2.0",
    description: "Social network for developers, built on the MERN stack",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/devconnector_2.0",
    forks_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/devconnector_2.0/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/devconnector_2.0/deployments",
    created_at: "2019-04-26T18:37:19Z",
    updated_at: "2021-11-03T02:40:18Z",
    pushed_at: "2021-11-03T18:09:38Z",
    git_url: "git://github.com/bradtraversy/devconnector_2.0.git",
    ssh_url: "git@github.com:bradtraversy/devconnector_2.0.git",
    clone_url: "https://github.com/bradtraversy/devconnector_2.0.git",
    svn_url: "https://github.com/bradtraversy/devconnector_2.0",
    homepage: null,
    size: 2297,
    stargazers_count: 1593,
    watchers_count: 1593,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1079,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 1079,
    open_issues: 4,
    watchers: 1593,
    default_branch: "master",
  },
  {
    id: 184256165,
    node_id: "MDEwOlJlcG9zaXRvcnkxODQyNTYxNjU=",
    name: "devconnector_theme_sass",
    full_name: "bradtraversy/devconnector_theme_sass",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/devconnector_theme_sass",
    description: "Theme / UI for DevConnector App",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/devconnector_theme_sass",
    forks_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/devconnector_theme_sass/deployments",
    created_at: "2019-04-30T12:14:28Z",
    updated_at: "2021-09-20T15:23:20Z",
    pushed_at: "2019-04-30T12:14:44Z",
    git_url: "git://github.com/bradtraversy/devconnector_theme_sass.git",
    ssh_url: "git@github.com:bradtraversy/devconnector_theme_sass.git",
    clone_url: "https://github.com/bradtraversy/devconnector_theme_sass.git",
    svn_url: "https://github.com/bradtraversy/devconnector_theme_sass",
    homepage: null,
    size: 305,
    stargazers_count: 75,
    watchers_count: 75,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 50,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 50,
    open_issues: 2,
    watchers: 75,
    default_branch: "master",
  },
  {
    id: 366748315,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjY3NDgzMTU=",
    name: "devspace-blog",
    full_name: "bradtraversy/devspace-blog",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/devspace-blog",
    description: "Development blog built with Next.js & Markdown",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/devspace-blog",
    forks_url: "https://api.github.com/repos/bradtraversy/devspace-blog/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/devspace-blog/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/devspace-blog/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/devspace-blog/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/devspace-blog/deployments",
    created_at: "2021-05-12T14:41:22Z",
    updated_at: "2021-09-30T06:15:52Z",
    pushed_at: "2021-06-09T10:40:49Z",
    git_url: "git://github.com/bradtraversy/devspace-blog.git",
    ssh_url: "git@github.com:bradtraversy/devspace-blog.git",
    clone_url: "https://github.com/bradtraversy/devspace-blog.git",
    svn_url: "https://github.com/bradtraversy/devspace-blog",
    homepage: "devspace-blog-eight.vercel.app",
    size: 2229,
    stargazers_count: 103,
    watchers_count: 103,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 26,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 26,
    open_issues: 1,
    watchers: 103,
    default_branch: "main",
  },
  {
    id: 261499200,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjE0OTkyMDA=",
    name: "DevYouTubeList",
    full_name: "bradtraversy/DevYouTubeList",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/DevYouTubeList",
    description: "List of Development YouTube Channels",
    fork: true,
    url: "https://api.github.com/repos/bradtraversy/DevYouTubeList",
    forks_url: "https://api.github.com/repos/bradtraversy/DevYouTubeList/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/DevYouTubeList/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/DevYouTubeList/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/DevYouTubeList/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/DevYouTubeList/deployments",
    created_at: "2020-05-05T14:45:23Z",
    updated_at: "2021-11-03T19:18:52Z",
    pushed_at: "2020-05-26T06:15:41Z",
    git_url: "git://github.com/bradtraversy/DevYouTubeList.git",
    ssh_url: "git@github.com:bradtraversy/DevYouTubeList.git",
    clone_url: "https://github.com/bradtraversy/DevYouTubeList.git",
    svn_url: "https://github.com/bradtraversy/DevYouTubeList",
    homepage: null,
    size: 383,
    stargazers_count: 95,
    watchers_count: 95,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 33,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 33,
    open_issues: 1,
    watchers: 95,
    default_branch: "master",
  },
  {
    id: 357578369,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTc1NzgzNjk=",
    name: "dj-events-backend",
    full_name: "bradtraversy/dj-events-backend",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/dj-events-backend",
    description: "Strapi backend/API for DJ events",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/dj-events-backend",
    forks_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/dj-events-backend/deployments",
    created_at: "2021-04-13T14:15:05Z",
    updated_at: "2021-10-28T03:21:44Z",
    pushed_at: "2021-04-14T18:02:18Z",
    git_url: "git://github.com/bradtraversy/dj-events-backend.git",
    ssh_url: "git@github.com:bradtraversy/dj-events-backend.git",
    clone_url: "https://github.com/bradtraversy/dj-events-backend.git",
    svn_url: "https://github.com/bradtraversy/dj-events-backend",
    homepage: null,
    size: 494,
    stargazers_count: 69,
    watchers_count: 69,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 31,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 31,
    open_issues: 1,
    watchers: 69,
    default_branch: "master",
  },
  {
    id: 357266538,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTcyNjY1Mzg=",
    name: "dj-events-frontend",
    full_name: "bradtraversy/dj-events-frontend",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/dj-events-frontend",
    description: "Next.js website to list DJ and other musical events",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/dj-events-frontend",
    forks_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/dj-events-frontend/deployments",
    created_at: "2021-04-12T16:35:11Z",
    updated_at: "2021-11-02T20:06:13Z",
    pushed_at: "2021-09-27T11:25:07Z",
    git_url: "git://github.com/bradtraversy/dj-events-frontend.git",
    ssh_url: "git@github.com:bradtraversy/dj-events-frontend.git",
    clone_url: "https://github.com/bradtraversy/dj-events-frontend.git",
    svn_url: "https://github.com/bradtraversy/dj-events-frontend",
    homepage: "djeventsfrontend-bradtraversy.vercel.app",
    size: 3267,
    stargazers_count: 205,
    watchers_count: 205,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 89,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 89,
    open_issues: 3,
    watchers: 205,
    default_branch: "main",
  },
  {
    id: 80350946,
    node_id: "MDEwOlJlcG9zaXRvcnk4MDM1MDk0Ng==",
    name: "django-todolist",
    full_name: "bradtraversy/django-todolist",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/django-todolist",
    description: "A simple todo list written in Python and Django",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/django-todolist",
    forks_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/django-todolist/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/django-todolist/deployments",
    created_at: "2017-01-29T14:34:45Z",
    updated_at: "2021-10-18T07:08:16Z",
    pushed_at: "2021-09-23T15:06:48Z",
    git_url: "git://github.com/bradtraversy/django-todolist.git",
    ssh_url: "git@github.com:bradtraversy/django-todolist.git",
    clone_url: "https://github.com/bradtraversy/django-todolist.git",
    svn_url: "https://github.com/bradtraversy/django-todolist",
    homepage: null,
    size: 12,
    stargazers_count: 68,
    watchers_count: 68,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 60,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 60,
    open_issues: 2,
    watchers: 68,
    default_branch: "master",
  },
  {
    id: 109828129,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDk4MjgxMjk=",
    name: "djangocrashcourse",
    full_name: "bradtraversy/djangocrashcourse",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/djangocrashcourse",
    description: "Very simple Django blog app for crash course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/djangocrashcourse",
    forks_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/djangocrashcourse/deployments",
    created_at: "2017-11-07T11:43:10Z",
    updated_at: "2021-09-20T15:24:16Z",
    pushed_at: "2017-11-07T11:44:41Z",
    git_url: "git://github.com/bradtraversy/djangocrashcourse.git",
    ssh_url: "git@github.com:bradtraversy/djangocrashcourse.git",
    clone_url: "https://github.com/bradtraversy/djangocrashcourse.git",
    svn_url: "https://github.com/bradtraversy/djangocrashcourse",
    homepage: null,
    size: 9,
    stargazers_count: 61,
    watchers_count: 61,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 49,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 49,
    open_issues: 2,
    watchers: 61,
    default_branch: "master",
  },
  {
    id: 144610372,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDQ2MTAzNzI=",
    name: "docker-node-mongo",
    full_name: "bradtraversy/docker-node-mongo",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/docker-node-mongo",
    description: "Sample node and mongo app that uses docker",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/docker-node-mongo",
    forks_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/docker-node-mongo/deployments",
    created_at: "2018-08-13T17:12:20Z",
    updated_at: "2021-10-29T11:33:17Z",
    pushed_at: "2021-05-07T15:26:28Z",
    git_url: "git://github.com/bradtraversy/docker-node-mongo.git",
    ssh_url: "git@github.com:bradtraversy/docker-node-mongo.git",
    clone_url: "https://github.com/bradtraversy/docker-node-mongo.git",
    svn_url: "https://github.com/bradtraversy/docker-node-mongo",
    homepage: "",
    size: 25,
    stargazers_count: 307,
    watchers_count: 307,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 356,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 8,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 356,
    open_issues: 8,
    watchers: 307,
    default_branch: "master",
  },
  {
    id: 106460917,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDY0NjA5MTc=",
    name: "ebookseller",
    full_name: "bradtraversy/ebookseller",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/ebookseller",
    description: "Node.js, Express Ebook sale using Stripe API",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/ebookseller",
    forks_url: "https://api.github.com/repos/bradtraversy/ebookseller/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/ebookseller/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/ebookseller/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/ebookseller/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/ebookseller/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/ebookseller/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/ebookseller/deployments",
    created_at: "2017-10-10T19:17:33Z",
    updated_at: "2021-09-20T15:24:14Z",
    pushed_at: "2017-10-10T19:22:19Z",
    git_url: "git://github.com/bradtraversy/ebookseller.git",
    ssh_url: "git@github.com:bradtraversy/ebookseller.git",
    clone_url: "https://github.com/bradtraversy/ebookseller.git",
    svn_url: "https://github.com/bradtraversy/ebookseller",
    homepage: null,
    size: 126,
    stargazers_count: 59,
    watchers_count: 59,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 53,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 53,
    open_issues: 1,
    watchers: 59,
    default_branch: "master",
  },
  {
    id: 262433904,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjI0MzM5MDQ=",
    name: "electron-course-files",
    full_name: "bradtraversy/electron-course-files",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/electron-course-files",
    description: "Files and apps for Electron course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/electron-course-files",
    forks_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/electron-course-files/deployments",
    created_at: "2020-05-08T21:38:48Z",
    updated_at: "2021-11-01T21:17:14Z",
    pushed_at: "2021-10-12T22:45:33Z",
    git_url: "git://github.com/bradtraversy/electron-course-files.git",
    ssh_url: "git@github.com:bradtraversy/electron-course-files.git",
    clone_url: "https://github.com/bradtraversy/electron-course-files.git",
    svn_url: "https://github.com/bradtraversy/electron-course-files",
    homepage: "",
    size: 14591,
    stargazers_count: 188,
    watchers_count: 188,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 80,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 61,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 80,
    open_issues: 61,
    watchers: 188,
    default_branch: "master",
  },
  {
    id: 103539873,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDM1Mzk4NzM=",
    name: "electronshoppinglist",
    full_name: "bradtraversy/electronshoppinglist",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/electronshoppinglist",
    description: "Shopping list desktop app built on electron",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/electronshoppinglist",
    forks_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/electronshoppinglist/deployments",
    created_at: "2017-09-14T14:05:43Z",
    updated_at: "2021-09-21T07:25:13Z",
    pushed_at: "2021-03-19T12:15:33Z",
    git_url: "git://github.com/bradtraversy/electronshoppinglist.git",
    ssh_url: "git@github.com:bradtraversy/electronshoppinglist.git",
    clone_url: "https://github.com/bradtraversy/electronshoppinglist.git",
    svn_url: "https://github.com/bradtraversy/electronshoppinglist",
    homepage: null,
    size: 221,
    stargazers_count: 201,
    watchers_count: 201,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 135,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 135,
    open_issues: 6,
    watchers: 201,
    default_branch: "master",
  },
  {
    id: 24495678,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDQ5NTY3OA==",
    name: "embertasks",
    full_name: "bradtraversy/embertasks",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/embertasks",
    description: "Simple Tasklist Using Ember.js",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/embertasks",
    forks_url: "https://api.github.com/repos/bradtraversy/embertasks/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/embertasks/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/embertasks/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/embertasks/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/embertasks/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/embertasks/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/embertasks/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/embertasks/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/embertasks/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/embertasks/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/embertasks/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/embertasks/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/embertasks/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/embertasks/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/embertasks/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/embertasks/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/embertasks/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/embertasks/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/embertasks/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/embertasks/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/embertasks/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/embertasks/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/embertasks/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/embertasks/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/embertasks/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/embertasks/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/embertasks/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/embertasks/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/embertasks/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/embertasks/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/embertasks/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/embertasks/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/embertasks/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/embertasks/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/embertasks/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/embertasks/deployments",
    created_at: "2014-09-26T10:30:34Z",
    updated_at: "2021-09-20T15:24:10Z",
    pushed_at: "2014-10-02T20:51:17Z",
    git_url: "git://github.com/bradtraversy/embertasks.git",
    ssh_url: "git@github.com:bradtraversy/embertasks.git",
    clone_url: "https://github.com/bradtraversy/embertasks.git",
    svn_url: "https://github.com/bradtraversy/embertasks",
    homepage: null,
    size: 480,
    stargazers_count: 4,
    watchers_count: 4,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 2,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 47930706,
    node_id: "MDEwOlJlcG9zaXRvcnk0NzkzMDcwNg==",
    name: "emtasks",
    full_name: "bradtraversy/emtasks",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/emtasks",
    description: "Task manager built with Ember.js",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/emtasks",
    forks_url: "https://api.github.com/repos/bradtraversy/emtasks/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/emtasks/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/emtasks/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/emtasks/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/emtasks/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/emtasks/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/emtasks/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/emtasks/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/emtasks/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/emtasks/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/emtasks/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/emtasks/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/emtasks/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/emtasks/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/emtasks/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/emtasks/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/emtasks/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/emtasks/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/emtasks/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/emtasks/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/emtasks/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/emtasks/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/emtasks/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/emtasks/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/emtasks/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/emtasks/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/emtasks/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/emtasks/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/emtasks/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/emtasks/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/emtasks/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/emtasks/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/emtasks/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/emtasks/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/emtasks/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/emtasks/deployments",
    created_at: "2015-12-13T18:16:44Z",
    updated_at: "2021-10-24T18:47:20Z",
    pushed_at: "2015-12-13T18:31:47Z",
    git_url: "git://github.com/bradtraversy/emtasks.git",
    ssh_url: "git@github.com:bradtraversy/emtasks.git",
    clone_url: "https://github.com/bradtraversy/emtasks.git",
    svn_url: "https://github.com/bradtraversy/emtasks",
    homepage: null,
    size: 12,
    stargazers_count: 20,
    watchers_count: 20,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 15,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 15,
    open_issues: 1,
    watchers: 20,
    default_branch: "master",
  },
  {
    id: 75087664,
    node_id: "MDEwOlJlcG9zaXRvcnk3NTA4NzY2NA==",
    name: "escalate_theme",
    full_name: "bradtraversy/escalate_theme",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/escalate_theme",
    description: "Simple Wordpress theme from Youtube series",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/escalate_theme",
    forks_url: "https://api.github.com/repos/bradtraversy/escalate_theme/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/escalate_theme/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/escalate_theme/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/escalate_theme/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/escalate_theme/deployments",
    created_at: "2016-11-29T14:12:14Z",
    updated_at: "2021-09-20T15:23:22Z",
    pushed_at: "2016-11-29T14:12:52Z",
    git_url: "git://github.com/bradtraversy/escalate_theme.git",
    ssh_url: "git@github.com:bradtraversy/escalate_theme.git",
    clone_url: "https://github.com/bradtraversy/escalate_theme.git",
    svn_url: "https://github.com/bradtraversy/escalate_theme",
    homepage: null,
    size: 233,
    stargazers_count: 14,
    watchers_count: 14,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 19,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 19,
    open_issues: 0,
    watchers: 14,
    default_branch: "master",
  },
  {
    id: 243030990,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDMwMzA5OTA=",
    name: "expense-tracker-mern",
    full_name: "bradtraversy/expense-tracker-mern",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/expense-tracker-mern",
    description: "Full stack expense tracker",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/expense-tracker-mern",
    forks_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-mern/deployments",
    created_at: "2020-02-25T15:15:52Z",
    updated_at: "2021-11-01T19:17:15Z",
    pushed_at: "2021-10-06T15:01:57Z",
    git_url: "git://github.com/bradtraversy/expense-tracker-mern.git",
    ssh_url: "git@github.com:bradtraversy/expense-tracker-mern.git",
    clone_url: "https://github.com/bradtraversy/expense-tracker-mern.git",
    svn_url: "https://github.com/bradtraversy/expense-tracker-mern",
    homepage: null,
    size: 5895,
    stargazers_count: 257,
    watchers_count: 257,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 113,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 28,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 113,
    open_issues: 28,
    watchers: 257,
    default_branch: "master",
  },
  {
    id: 242376026,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDIzNzYwMjY=",
    name: "expense-tracker-react",
    full_name: "bradtraversy/expense-tracker-react",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/expense-tracker-react",
    description: "Simple expense tracker using React hooks & context",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/expense-tracker-react",
    forks_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/expense-tracker-react/deployments",
    created_at: "2020-02-22T16:45:20Z",
    updated_at: "2021-11-01T19:17:14Z",
    pushed_at: "2021-10-20T13:35:27Z",
    git_url: "git://github.com/bradtraversy/expense-tracker-react.git",
    ssh_url: "git@github.com:bradtraversy/expense-tracker-react.git",
    clone_url: "https://github.com/bradtraversy/expense-tracker-react.git",
    svn_url: "https://github.com/bradtraversy/expense-tracker-react",
    homepage: null,
    size: 4483,
    stargazers_count: 351,
    watchers_count: 351,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 230,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 18,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 230,
    open_issues: 18,
    watchers: 351,
    default_branch: "master",
  },
  {
    id: 172079325,
    node_id: "MDEwOlJlcG9zaXRvcnkxNzIwNzkzMjU=",
    name: "express_crash_course",
    full_name: "bradtraversy/express_crash_course",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/express_crash_course",
    description: "Express crash course on YouTube",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/express_crash_course",
    forks_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/express_crash_course/deployments",
    created_at: "2019-02-22T14:24:17Z",
    updated_at: "2021-10-29T10:47:24Z",
    pushed_at: "2021-08-21T16:07:19Z",
    git_url: "git://github.com/bradtraversy/express_crash_course.git",
    ssh_url: "git@github.com:bradtraversy/express_crash_course.git",
    clone_url: "https://github.com/bradtraversy/express_crash_course.git",
    svn_url: "https://github.com/bradtraversy/express_crash_course",
    homepage: null,
    size: 140,
    stargazers_count: 273,
    watchers_count: 273,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 182,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 182,
    open_issues: 6,
    watchers: 273,
    default_branch: "master",
  },
  {
    id: 179122408,
    node_id: "MDEwOlJlcG9zaXRvcnkxNzkxMjI0MDg=",
    name: "face_recognition_examples",
    full_name: "bradtraversy/face_recognition_examples",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/face_recognition_examples",
    description: "Examples for Python Face Recognition library",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/face_recognition_examples",
    forks_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/face_recognition_examples/deployments",
    created_at: "2019-04-02T17:00:59Z",
    updated_at: "2021-10-24T06:50:42Z",
    pushed_at: "2019-04-02T17:02:11Z",
    git_url: "git://github.com/bradtraversy/face_recognition_examples.git",
    ssh_url: "git@github.com:bradtraversy/face_recognition_examples.git",
    clone_url: "https://github.com/bradtraversy/face_recognition_examples.git",
    svn_url: "https://github.com/bradtraversy/face_recognition_examples",
    homepage: null,
    size: 5516,
    stargazers_count: 149,
    watchers_count: 149,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 123,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 123,
    open_issues: 0,
    watchers: 149,
    default_branch: "master",
  },
  {
    id: 137266984,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzcyNjY5ODQ=",
    name: "fancy_form",
    full_name: "bradtraversy/fancy_form",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/fancy_form",
    description: "HTML/CSS/JS/Sass Form UI with progress bar",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/fancy_form",
    forks_url: "https://api.github.com/repos/bradtraversy/fancy_form/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/fancy_form/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/fancy_form/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/fancy_form/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/fancy_form/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/fancy_form/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/fancy_form/deployments",
    created_at: "2018-06-13T20:27:36Z",
    updated_at: "2021-11-03T19:19:13Z",
    pushed_at: "2021-08-04T23:05:29Z",
    git_url: "git://github.com/bradtraversy/fancy_form.git",
    ssh_url: "git@github.com:bradtraversy/fancy_form.git",
    clone_url: "https://github.com/bradtraversy/fancy_form.git",
    svn_url: "https://github.com/bradtraversy/fancy_form",
    homepage: null,
    size: 81,
    stargazers_count: 72,
    watchers_count: 72,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 25,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 8,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 25,
    open_issues: 8,
    watchers: 72,
    default_branch: "master",
  },
  {
    id: 377970846,
    node_id: "MDEwOlJlcG9zaXRvcnkzNzc5NzA4NDY=",
    name: "fastify-crash-course",
    full_name: "bradtraversy/fastify-crash-course",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/fastify-crash-course",
    description: "API built with Fastify",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/fastify-crash-course",
    forks_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/fastify-crash-course/deployments",
    created_at: "2021-06-17T22:04:48Z",
    updated_at: "2021-10-26T04:49:23Z",
    pushed_at: "2021-06-19T12:07:56Z",
    git_url: "git://github.com/bradtraversy/fastify-crash-course.git",
    ssh_url: "git@github.com:bradtraversy/fastify-crash-course.git",
    clone_url: "https://github.com/bradtraversy/fastify-crash-course.git",
    svn_url: "https://github.com/bradtraversy/fastify-crash-course",
    homepage: null,
    size: 42,
    stargazers_count: 122,
    watchers_count: 122,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 20,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 20,
    open_issues: 0,
    watchers: 122,
    default_branch: "main",
  },
  {
    id: 121296961,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjEyOTY5NjE=",
    name: "finddit",
    full_name: "bradtraversy/finddit",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/finddit",
    description: "Reddit search app using ES6 and Parcel",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/finddit",
    forks_url: "https://api.github.com/repos/bradtraversy/finddit/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/finddit/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/finddit/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/finddit/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/finddit/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/finddit/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/finddit/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/finddit/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/finddit/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/finddit/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/finddit/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/finddit/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/finddit/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/finddit/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/finddit/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/finddit/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/finddit/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/finddit/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/finddit/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/finddit/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/finddit/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/finddit/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/finddit/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/finddit/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/finddit/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/finddit/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/finddit/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/finddit/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/finddit/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/finddit/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/finddit/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/finddit/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/finddit/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/finddit/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/finddit/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/finddit/deployments",
    created_at: "2018-02-12T20:19:22Z",
    updated_at: "2021-09-21T11:29:30Z",
    pushed_at: "2018-02-13T01:26:40Z",
    git_url: "git://github.com/bradtraversy/finddit.git",
    ssh_url: "git@github.com:bradtraversy/finddit.git",
    clone_url: "https://github.com/bradtraversy/finddit.git",
    svn_url: "https://github.com/bradtraversy/finddit",
    homepage: null,
    size: 6762,
    stargazers_count: 35,
    watchers_count: 35,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 32,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 32,
    open_issues: 0,
    watchers: 35,
    default_branch: "master",
  },
  {
    id: 139501809,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzk1MDE4MDk=",
    name: "find_a_pet",
    full_name: "bradtraversy/find_a_pet",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/find_a_pet",
    description:
      "JavaScript app that uses the Petfinder API to find pets by zipcode",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/find_a_pet",
    forks_url: "https://api.github.com/repos/bradtraversy/find_a_pet/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/find_a_pet/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/find_a_pet/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/find_a_pet/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/find_a_pet/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/find_a_pet/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/find_a_pet/deployments",
    created_at: "2018-07-02T22:39:26Z",
    updated_at: "2021-11-01T19:15:17Z",
    pushed_at: "2021-09-23T19:54:09Z",
    git_url: "git://github.com/bradtraversy/find_a_pet.git",
    ssh_url: "git@github.com:bradtraversy/find_a_pet.git",
    clone_url: "https://github.com/bradtraversy/find_a_pet.git",
    svn_url: "https://github.com/bradtraversy/find_a_pet",
    homepage: null,
    size: 21,
    stargazers_count: 30,
    watchers_count: 30,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 23,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 23,
    open_issues: 0,
    watchers: 30,
    default_branch: "master",
  },
  {
    id: 100860698,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDA4NjA2OTg=",
    name: "firebasecontact",
    full_name: "bradtraversy/firebasecontact",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/firebasecontact",
    description: "Simple firebase contact form",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/firebasecontact",
    forks_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/firebasecontact/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/firebasecontact/deployments",
    created_at: "2017-08-20T12:42:42Z",
    updated_at: "2021-09-30T14:49:53Z",
    pushed_at: "2017-12-12T00:35:57Z",
    git_url: "git://github.com/bradtraversy/firebasecontact.git",
    ssh_url: "git@github.com:bradtraversy/firebasecontact.git",
    clone_url: "https://github.com/bradtraversy/firebasecontact.git",
    svn_url: "https://github.com/bradtraversy/firebasecontact",
    homepage: null,
    size: 3,
    stargazers_count: 104,
    watchers_count: 104,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 124,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 124,
    open_issues: 4,
    watchers: 104,
    default_branch: "master",
  },
  {
    id: 89273152,
    node_id: "MDEwOlJlcG9zaXRvcnk4OTI3MzE1Mg==",
    name: "flask-wysiwyg",
    full_name: "bradtraversy/flask-wysiwyg",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/flask-wysiwyg",
    description:
      "flask-wysiwyg provides custom form fields to render wysiwyg editor instead of regular textareas. It takes care of cleaning html for you too. With its super secure defaults you do not want to modified it's whitelisting rules.",
    fork: true,
    url: "https://api.github.com/repos/bradtraversy/flask-wysiwyg",
    forks_url: "https://api.github.com/repos/bradtraversy/flask-wysiwyg/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/flask-wysiwyg/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/flask-wysiwyg/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/flask-wysiwyg/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/flask-wysiwyg/deployments",
    created_at: "2017-04-24T18:21:46Z",
    updated_at: "2021-09-20T15:24:02Z",
    pushed_at: "2014-07-08T09:34:39Z",
    git_url: "git://github.com/bradtraversy/flask-wysiwyg.git",
    ssh_url: "git@github.com:bradtraversy/flask-wysiwyg.git",
    clone_url: "https://github.com/bradtraversy/flask-wysiwyg.git",
    svn_url: "https://github.com/bradtraversy/flask-wysiwyg",
    homepage: null,
    size: 612,
    stargazers_count: 4,
    watchers_count: 4,
    language: "Python",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 4,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 164459958,
    node_id: "MDEwOlJlcG9zaXRvcnkxNjQ0NTk5NTg=",
    name: "flask_sqlalchemy_rest",
    full_name: "bradtraversy/flask_sqlalchemy_rest",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/flask_sqlalchemy_rest",
    description: "Products REST API using Flask, SQL Alchemy & Marshmallow",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest",
    forks_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/flask_sqlalchemy_rest/deployments",
    created_at: "2019-01-07T16:28:12Z",
    updated_at: "2021-10-28T20:49:20Z",
    pushed_at: "2019-01-07T16:30:15Z",
    git_url: "git://github.com/bradtraversy/flask_sqlalchemy_rest.git",
    ssh_url: "git@github.com:bradtraversy/flask_sqlalchemy_rest.git",
    clone_url: "https://github.com/bradtraversy/flask_sqlalchemy_rest.git",
    svn_url: "https://github.com/bradtraversy/flask_sqlalchemy_rest",
    homepage: null,
    size: 4,
    stargazers_count: 135,
    watchers_count: 135,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 90,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 90,
    open_issues: 3,
    watchers: 135,
    default_branch: "master",
  },
  {
    id: 51307506,
    node_id: "MDEwOlJlcG9zaXRvcnk1MTMwNzUwNg==",
    name: "fluxboiler",
    full_name: "bradtraversy/fluxboiler",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/fluxboiler",
    description: "Boilerplate for building flux and React.js applications",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/fluxboiler",
    forks_url: "https://api.github.com/repos/bradtraversy/fluxboiler/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/fluxboiler/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/fluxboiler/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/fluxboiler/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/fluxboiler/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/fluxboiler/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/fluxboiler/deployments",
    created_at: "2016-02-08T15:53:12Z",
    updated_at: "2020-03-10T20:47:31Z",
    pushed_at: "2017-10-04T13:22:58Z",
    git_url: "git://github.com/bradtraversy/fluxboiler.git",
    ssh_url: "git@github.com:bradtraversy/fluxboiler.git",
    clone_url: "https://github.com/bradtraversy/fluxboiler.git",
    svn_url: "https://github.com/bradtraversy/fluxboiler",
    homepage: null,
    size: 70,
    stargazers_count: 27,
    watchers_count: 27,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 29,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 29,
    open_issues: 2,
    watchers: 27,
    default_branch: "master",
  },
  {
    id: 408136973,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDgxMzY5NzM=",
    name: "frontend-mentor-challenges",
    full_name: "bradtraversy/frontend-mentor-challenges",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/frontend-mentor-challenges",
    description: "My submissions for the Frontend Mentor Challenges",
    fork: true,
    url: "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges",
    forks_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/frontend-mentor-challenges/deployments",
    created_at: "2021-09-19T13:38:11Z",
    updated_at: "2021-09-23T01:56:26Z",
    pushed_at: "2020-09-02T10:29:10Z",
    git_url: "git://github.com/bradtraversy/frontend-mentor-challenges.git",
    ssh_url: "git@github.com:bradtraversy/frontend-mentor-challenges.git",
    clone_url: "https://github.com/bradtraversy/frontend-mentor-challenges.git",
    svn_url: "https://github.com/bradtraversy/frontend-mentor-challenges",
    homepage: null,
    size: 4543,
    stargazers_count: 4,
    watchers_count: 4,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 129290320,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjkyOTAzMjA=",
    name: "gatsby_crash_course",
    full_name: "bradtraversy/gatsby_crash_course",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/gatsby_crash_course",
    description: "Sample website built with Gatsby",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/gatsby_crash_course",
    forks_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/gatsby_crash_course/deployments",
    created_at: "2018-04-12T17:47:35Z",
    updated_at: "2021-11-03T19:18:53Z",
    pushed_at: "2020-09-30T18:18:35Z",
    git_url: "git://github.com/bradtraversy/gatsby_crash_course.git",
    ssh_url: "git@github.com:bradtraversy/gatsby_crash_course.git",
    clone_url: "https://github.com/bradtraversy/gatsby_crash_course.git",
    svn_url: "https://github.com/bradtraversy/gatsby_crash_course",
    homepage: null,
    size: 188,
    stargazers_count: 83,
    watchers_count: 83,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 81,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 81,
    open_issues: 0,
    watchers: 83,
    default_branch: "master",
  },
  {
    id: 189859257,
    node_id: "MDEwOlJlcG9zaXRvcnkxODk4NTkyNTc=",
    name: "github-finder",
    full_name: "bradtraversy/github-finder",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/github-finder",
    description: "Search Github users - React hooks & context",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/github-finder",
    forks_url: "https://api.github.com/repos/bradtraversy/github-finder/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/github-finder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/github-finder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/github-finder/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/github-finder/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/github-finder/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/github-finder/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/github-finder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/github-finder/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/github-finder/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/github-finder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/github-finder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/github-finder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/github-finder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/github-finder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/github-finder/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/github-finder/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/github-finder/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/github-finder/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/github-finder/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/github-finder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/github-finder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/github-finder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/github-finder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/github-finder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/github-finder/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/github-finder/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/github-finder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/github-finder/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/github-finder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/github-finder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/github-finder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/github-finder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/github-finder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/github-finder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/github-finder/deployments",
    created_at: "2019-06-02T14:53:15Z",
    updated_at: "2021-10-29T04:50:06Z",
    pushed_at: "2021-10-05T22:28:46Z",
    git_url: "git://github.com/bradtraversy/github-finder.git",
    ssh_url: "git@github.com:bradtraversy/github-finder.git",
    clone_url: "https://github.com/bradtraversy/github-finder.git",
    svn_url: "https://github.com/bradtraversy/github-finder",
    homepage: null,
    size: 6388,
    stargazers_count: 333,
    watchers_count: 333,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 274,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 14,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 274,
    open_issues: 14,
    watchers: 333,
    default_branch: "master",
  },
  {
    id: 62821432,
    node_id: "MDEwOlJlcG9zaXRvcnk2MjgyMTQzMg==",
    name: "githubsearch",
    full_name: "bradtraversy/githubsearch",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/githubsearch",
    description: "Angular 2 Github profile search application",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/githubsearch",
    forks_url: "https://api.github.com/repos/bradtraversy/githubsearch/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/githubsearch/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/githubsearch/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/githubsearch/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/githubsearch/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/githubsearch/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/githubsearch/deployments",
    created_at: "2016-07-07T16:23:20Z",
    updated_at: "2020-12-13T20:13:42Z",
    pushed_at: "2016-12-16T14:09:39Z",
    git_url: "git://github.com/bradtraversy/githubsearch.git",
    ssh_url: "git@github.com:bradtraversy/githubsearch.git",
    clone_url: "https://github.com/bradtraversy/githubsearch.git",
    svn_url: "https://github.com/bradtraversy/githubsearch",
    homepage: null,
    size: 27,
    stargazers_count: 16,
    watchers_count: 16,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 21,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 21,
    open_issues: 1,
    watchers: 16,
    default_branch: "master",
  },
  {
    id: 149327421,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDkzMjc0MjE=",
    name: "go_crash_course",
    full_name: "bradtraversy/go_crash_course",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/go_crash_course",
    description: "Basics of the go language",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/go_crash_course",
    forks_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/go_crash_course/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/go_crash_course/deployments",
    created_at: "2018-09-18T17:31:19Z",
    updated_at: "2021-10-26T12:22:22Z",
    pushed_at: "2021-08-16T17:21:32Z",
    git_url: "git://github.com/bradtraversy/go_crash_course.git",
    ssh_url: "git@github.com:bradtraversy/go_crash_course.git",
    clone_url: "https://github.com/bradtraversy/go_crash_course.git",
    svn_url: "https://github.com/bradtraversy/go_crash_course",
    homepage: null,
    size: 6,
    stargazers_count: 206,
    watchers_count: 206,
    language: "Go",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 94,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 94,
    open_issues: 1,
    watchers: 206,
    default_branch: "master",
  },
  {
    id: 116991123,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTY5OTExMjM=",
    name: "go_restapi",
    full_name: "bradtraversy/go_restapi",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/go_restapi",
    description: "Simple RESTful API using Golang",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/go_restapi",
    forks_url: "https://api.github.com/repos/bradtraversy/go_restapi/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/go_restapi/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/go_restapi/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/go_restapi/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/go_restapi/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/go_restapi/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/go_restapi/deployments",
    created_at: "2018-01-10T17:48:22Z",
    updated_at: "2021-10-31T16:23:40Z",
    pushed_at: "2020-09-25T21:19:08Z",
    git_url: "git://github.com/bradtraversy/go_restapi.git",
    ssh_url: "git@github.com:bradtraversy/go_restapi.git",
    clone_url: "https://github.com/bradtraversy/go_restapi.git",
    svn_url: "https://github.com/bradtraversy/go_restapi",
    homepage: null,
    size: 4,
    stargazers_count: 180,
    watchers_count: 180,
    language: "Go",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 109,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 109,
    open_issues: 3,
    watchers: 180,
    default_branch: "master",
  },
  {
    id: 91820191,
    node_id: "MDEwOlJlcG9zaXRvcnk5MTgyMDE5MQ==",
    name: "gulpexapp",
    full_name: "bradtraversy/gulpexapp",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/gulpexapp",
    description: "Gulp example/starter app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/gulpexapp",
    forks_url: "https://api.github.com/repos/bradtraversy/gulpexapp/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/gulpexapp/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/gulpexapp/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/gulpexapp/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/gulpexapp/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/gulpexapp/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/gulpexapp/deployments",
    created_at: "2017-05-19T15:32:25Z",
    updated_at: "2021-09-29T14:52:01Z",
    pushed_at: "2019-10-14T12:49:00Z",
    git_url: "git://github.com/bradtraversy/gulpexapp.git",
    ssh_url: "git@github.com:bradtraversy/gulpexapp.git",
    clone_url: "https://github.com/bradtraversy/gulpexapp.git",
    svn_url: "https://github.com/bradtraversy/gulpexapp",
    homepage: null,
    size: 9,
    stargazers_count: 48,
    watchers_count: 48,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 41,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 41,
    open_issues: 0,
    watchers: 48,
    default_branch: "master",
  },
  {
    id: 96789836,
    node_id: "MDEwOlJlcG9zaXRvcnk5Njc4OTgzNg==",
    name: "hapiapp",
    full_name: "bradtraversy/hapiapp",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/hapiapp",
    description: "Hapi.js crash course app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/hapiapp",
    forks_url: "https://api.github.com/repos/bradtraversy/hapiapp/forks",
    keys_url: "https://api.github.com/repos/bradtraversy/hapiapp/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/hapiapp/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/hapiapp/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/hapiapp/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/hapiapp/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/hapiapp/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/hapiapp/deployments",
    created_at: "2017-07-10T14:56:47Z",
    updated_at: "2021-09-22T09:01:20Z",
    pushed_at: "2021-06-10T21:27:40Z",
    git_url: "git://github.com/bradtraversy/hapiapp.git",
    ssh_url: "git@github.com:bradtraversy/hapiapp.git",
    clone_url: "https://github.com/bradtraversy/hapiapp.git",
    svn_url: "https://github.com/bradtraversy/hapiapp",
    homepage: null,
    size: 207,
    stargazers_count: 40,
    watchers_count: 40,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 8,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 8,
    open_issues: 5,
    watchers: 40,
    default_branch: "master",
  },
  {
    id: 24496084,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDQ5NjA4NA==",
    name: "html5audioplayer",
    full_name: "bradtraversy/html5audioplayer",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/html5audioplayer",
    description:
      "HTML5 Audio Player uses the HTML5 audio API to create playlists and play, pause and skip through tracks.",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/html5audioplayer",
    forks_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/html5audioplayer/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/html5audioplayer/deployments",
    created_at: "2014-09-26T10:46:28Z",
    updated_at: "2021-10-05T19:48:51Z",
    pushed_at: "2014-10-24T11:07:49Z",
    git_url: "git://github.com/bradtraversy/html5audioplayer.git",
    ssh_url: "git@github.com:bradtraversy/html5audioplayer.git",
    clone_url: "https://github.com/bradtraversy/html5audioplayer.git",
    svn_url: "https://github.com/bradtraversy/html5audioplayer",
    homepage: null,
    size: 90788,
    stargazers_count: 47,
    watchers_count: 47,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 51,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 51,
    open_issues: 4,
    watchers: 47,
    default_branch: "master",
  },
  {
    id: 408568039,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDg1NjgwMzk=",
    name: "huddle_styled_components",
    full_name: "bradtraversy/huddle_styled_components",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/huddle_styled_components",
    description: "Landing page from styled components crash course",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/huddle_styled_components",
    forks_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/huddle_styled_components/deployments",
    created_at: "2021-09-20T19:04:11Z",
    updated_at: "2021-10-29T16:40:11Z",
    pushed_at: "2021-09-21T14:10:02Z",
    git_url: "git://github.com/bradtraversy/huddle_styled_components.git",
    ssh_url: "git@github.com:bradtraversy/huddle_styled_components.git",
    clone_url: "https://github.com/bradtraversy/huddle_styled_components.git",
    svn_url: "https://github.com/bradtraversy/huddle_styled_components",
    homepage: null,
    size: 663,
    stargazers_count: 77,
    watchers_count: 77,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 34,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 34,
    open_issues: 0,
    watchers: 77,
    default_branch: "main",
  },
  {
    id: 386010090,
    node_id: "MDEwOlJlcG9zaXRvcnkzODYwMTAwOTA=",
    name: "hulu-webpage-clone",
    full_name: "bradtraversy/hulu-webpage-clone",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/hulu-webpage-clone",
    description: "Hulu webpage clone",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/hulu-webpage-clone",
    forks_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/hulu-webpage-clone/deployments",
    created_at: "2021-07-14T16:45:37Z",
    updated_at: "2021-10-30T14:14:01Z",
    pushed_at: "2021-11-01T18:05:59Z",
    git_url: "git://github.com/bradtraversy/hulu-webpage-clone.git",
    ssh_url: "git@github.com:bradtraversy/hulu-webpage-clone.git",
    clone_url: "https://github.com/bradtraversy/hulu-webpage-clone.git",
    svn_url: "https://github.com/bradtraversy/hulu-webpage-clone",
    homepage: null,
    size: 2394,
    stargazers_count: 276,
    watchers_count: 276,
    language: "CSS",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 101,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 101,
    open_issues: 4,
    watchers: 276,
    default_branch: "main",
  },
  {
    id: 171132280,
    node_id: "MDEwOlJlcG9zaXRvcnkxNzExMzIyODA=",
    name: "infinite_scroll_react_unsplash",
    full_name: "bradtraversy/infinite_scroll_react_unsplash",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/infinite_scroll_react_unsplash",
    description: "Image gallery using infinite scrolling in React",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash",
    forks_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/infinite_scroll_react_unsplash/deployments",
    created_at: "2019-02-17T14:34:52Z",
    updated_at: "2021-11-03T19:18:54Z",
    pushed_at: "2020-12-04T06:12:33Z",
    git_url: "git://github.com/bradtraversy/infinite_scroll_react_unsplash.git",
    ssh_url: "git@github.com:bradtraversy/infinite_scroll_react_unsplash.git",
    clone_url:
      "https://github.com/bradtraversy/infinite_scroll_react_unsplash.git",
    svn_url: "https://github.com/bradtraversy/infinite_scroll_react_unsplash",
    homepage: null,
    size: 307,
    stargazers_count: 61,
    watchers_count: 61,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 23,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 23,
    open_issues: 2,
    watchers: 61,
    default_branch: "master",
  },
  {
    id: 76120888,
    node_id: "MDEwOlJlcG9zaXRvcnk3NjEyMDg4OA==",
    name: "ionreddit",
    full_name: "bradtraversy/ionreddit",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/ionreddit",
    description: "Ionic 2 mobile app to read and categorize subreddits",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/ionreddit",
    forks_url: "https://api.github.com/repos/bradtraversy/ionreddit/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/ionreddit/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/ionreddit/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/ionreddit/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/ionreddit/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/ionreddit/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/ionreddit/deployments",
    created_at: "2016-12-10T15:29:28Z",
    updated_at: "2021-09-19T11:20:03Z",
    pushed_at: "2017-07-07T23:45:36Z",
    git_url: "git://github.com/bradtraversy/ionreddit.git",
    ssh_url: "git@github.com:bradtraversy/ionreddit.git",
    clone_url: "https://github.com/bradtraversy/ionreddit.git",
    svn_url: "https://github.com/bradtraversy/ionreddit",
    homepage: null,
    size: 998,
    stargazers_count: 52,
    watchers_count: 52,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 42,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 42,
    open_issues: 5,
    watchers: 52,
    default_branch: "master",
  },
  {
    id: 189859894,
    node_id: "MDEwOlJlcG9zaXRvcnkxODk4NTk4OTQ=",
    name: "it-logger",
    full_name: "bradtraversy/it-logger",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/it-logger",
    description: "Tracks IT dept issues",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/it-logger",
    forks_url: "https://api.github.com/repos/bradtraversy/it-logger/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/it-logger/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/it-logger/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/it-logger/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/it-logger/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/it-logger/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/it-logger/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/it-logger/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/it-logger/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/it-logger/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/it-logger/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/it-logger/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/it-logger/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/it-logger/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/it-logger/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/it-logger/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/it-logger/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/it-logger/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/it-logger/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/it-logger/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/it-logger/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/it-logger/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/it-logger/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/it-logger/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/it-logger/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/it-logger/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/it-logger/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/it-logger/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/it-logger/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/it-logger/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/it-logger/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/it-logger/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/it-logger/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/it-logger/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/it-logger/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/it-logger/deployments",
    created_at: "2019-06-02T14:58:40Z",
    updated_at: "2021-10-21T14:50:53Z",
    pushed_at: "2021-10-05T22:14:57Z",
    git_url: "git://github.com/bradtraversy/it-logger.git",
    ssh_url: "git@github.com:bradtraversy/it-logger.git",
    clone_url: "https://github.com/bradtraversy/it-logger.git",
    svn_url: "https://github.com/bradtraversy/it-logger",
    homepage: null,
    size: 5604,
    stargazers_count: 142,
    watchers_count: 142,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 81,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 14,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 81,
    open_issues: 14,
    watchers: 142,
    default_branch: "master",
  },
  {
    id: 100102403,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDAxMDI0MDM=",
    name: "iweather",
    full_name: "bradtraversy/iweather",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/iweather",
    description: "Ionic 3 mobile weather app",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/iweather",
    forks_url: "https://api.github.com/repos/bradtraversy/iweather/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/iweather/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/iweather/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/iweather/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/iweather/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/iweather/issues/events{/number}",
    events_url: "https://api.github.com/repos/bradtraversy/iweather/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/iweather/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/iweather/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/iweather/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/iweather/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/iweather/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/iweather/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/iweather/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/iweather/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/iweather/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/iweather/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/iweather/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/iweather/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/iweather/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/iweather/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/iweather/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/iweather/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/iweather/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/iweather/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/iweather/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/bradtraversy/iweather/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/iweather/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/iweather/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/iweather/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/iweather/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/iweather/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/iweather/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/iweather/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/iweather/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/iweather/deployments",
    created_at: "2017-08-12T09:27:30Z",
    updated_at: "2021-09-20T15:22:48Z",
    pushed_at: "2018-03-26T12:34:51Z",
    git_url: "git://github.com/bradtraversy/iweather.git",
    ssh_url: "git@github.com:bradtraversy/iweather.git",
    clone_url: "https://github.com/bradtraversy/iweather.git",
    svn_url: "https://github.com/bradtraversy/iweather",
    homepage: null,
    size: 13702,
    stargazers_count: 83,
    watchers_count: 83,
    language: "TypeScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 56,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 56,
    open_issues: 5,
    watchers: 83,
    default_branch: "master",
  },
  {
    id: 121767154,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjE3NjcxNTQ=",
    name: "javascript_cardio",
    full_name: "bradtraversy/javascript_cardio",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/javascript_cardio",
    description: "JavaScript challenges and problems",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/javascript_cardio",
    forks_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/javascript_cardio/deployments",
    created_at: "2018-02-16T15:35:59Z",
    updated_at: "2021-11-03T19:21:40Z",
    pushed_at: "2021-10-29T16:23:55Z",
    git_url: "git://github.com/bradtraversy/javascript_cardio.git",
    ssh_url: "git@github.com:bradtraversy/javascript_cardio.git",
    clone_url: "https://github.com/bradtraversy/javascript_cardio.git",
    svn_url: "https://github.com/bradtraversy/javascript_cardio",
    homepage: null,
    size: 90,
    stargazers_count: 370,
    watchers_count: 370,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 303,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 10,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 303,
    open_issues: 10,
    watchers: 370,
    default_branch: "master",
  },
  {
    id: 130412989,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzA0MTI5ODk=",
    name: "jest_testing_basics",
    full_name: "bradtraversy/jest_testing_basics",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jest_testing_basics",
    description: "Some basic Jest unit testing examples",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jest_testing_basics",
    forks_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jest_testing_basics/deployments",
    created_at: "2018-04-20T20:55:09Z",
    updated_at: "2021-10-28T19:30:49Z",
    pushed_at: "2018-04-20T20:56:50Z",
    git_url: "git://github.com/bradtraversy/jest_testing_basics.git",
    ssh_url: "git@github.com:bradtraversy/jest_testing_basics.git",
    clone_url: "https://github.com/bradtraversy/jest_testing_basics.git",
    svn_url: "https://github.com/bradtraversy/jest_testing_basics",
    homepage: null,
    size: 46,
    stargazers_count: 116,
    watchers_count: 116,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 93,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 93,
    open_issues: 0,
    watchers: 116,
    default_branch: "master",
  },
  {
    id: 79351073,
    node_id: "MDEwOlJlcG9zaXRvcnk3OTM1MTA3Mw==",
    name: "jquery-githubfinder",
    full_name: "bradtraversy/jquery-githubfinder",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jquery-githubfinder",
    description: "Github profile finder using jQuery and Ajax",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jquery-githubfinder",
    forks_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jquery-githubfinder/deployments",
    created_at: "2017-01-18T15:03:02Z",
    updated_at: "2021-10-17T07:53:46Z",
    pushed_at: "2020-05-09T13:01:33Z",
    git_url: "git://github.com/bradtraversy/jquery-githubfinder.git",
    ssh_url: "git@github.com:bradtraversy/jquery-githubfinder.git",
    clone_url: "https://github.com/bradtraversy/jquery-githubfinder.git",
    svn_url: "https://github.com/bradtraversy/jquery-githubfinder",
    homepage: null,
    size: 30,
    stargazers_count: 48,
    watchers_count: 48,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 46,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 46,
    open_issues: 1,
    watchers: 48,
    default_branch: "master",
  },
  {
    id: 24990926,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDk5MDkyNg==",
    name: "jquery.linkIt",
    full_name: "bradtraversy/jquery.linkIt",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jquery.linkIt",
    description:
      "Simple jQuery plugin that allows you to attach a link to any element",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jquery.linkIt",
    forks_url: "https://api.github.com/repos/bradtraversy/jquery.linkIt/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/jquery.linkIt/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/jquery.linkIt/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/jquery.linkIt/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jquery.linkIt/deployments",
    created_at: "2014-10-09T13:43:40Z",
    updated_at: "2020-03-10T20:48:39Z",
    pushed_at: "2014-10-09T14:59:04Z",
    git_url: "git://github.com/bradtraversy/jquery.linkIt.git",
    ssh_url: "git@github.com:bradtraversy/jquery.linkIt.git",
    clone_url: "https://github.com/bradtraversy/jquery.linkIt.git",
    svn_url: "https://github.com/bradtraversy/jquery.linkIt",
    homepage: null,
    size: 132,
    stargazers_count: 2,
    watchers_count: 2,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 3,
    open_issues: 0,
    watchers: 2,
    default_branch: "master",
  },
  {
    id: 24736740,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDczNjc0MA==",
    name: "jquery.scrollSlide",
    full_name: "bradtraversy/jquery.scrollSlide",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jquery.scrollSlide",
    description:
      "A plugin to run a slide animation at a specified scroll position",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jquery.scrollSlide",
    forks_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jquery.scrollSlide/deployments",
    created_at: "2014-10-02T21:08:35Z",
    updated_at: "2021-03-19T06:14:34Z",
    pushed_at: "2014-10-03T13:28:21Z",
    git_url: "git://github.com/bradtraversy/jquery.scrollSlide.git",
    ssh_url: "git@github.com:bradtraversy/jquery.scrollSlide.git",
    clone_url: "https://github.com/bradtraversy/jquery.scrollSlide.git",
    svn_url: "https://github.com/bradtraversy/jquery.scrollSlide",
    homepage: null,
    size: 508,
    stargazers_count: 13,
    watchers_count: 13,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 7,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 7,
    open_issues: 0,
    watchers: 13,
    default_branch: "master",
  },
  {
    id: 68521201,
    node_id: "MDEwOlJlcG9zaXRvcnk2ODUyMTIwMQ==",
    name: "jquery_crash_course",
    full_name: "bradtraversy/jquery_crash_course",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jquery_crash_course",
    description: "Simple jQuery examples from Youtube series",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jquery_crash_course",
    forks_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jquery_crash_course/deployments",
    created_at: "2016-09-18T12:49:46Z",
    updated_at: "2021-11-02T22:00:38Z",
    pushed_at: "2019-10-06T14:39:55Z",
    git_url: "git://github.com/bradtraversy/jquery_crash_course.git",
    ssh_url: "git@github.com:bradtraversy/jquery_crash_course.git",
    clone_url: "https://github.com/bradtraversy/jquery_crash_course.git",
    svn_url: "https://github.com/bradtraversy/jquery_crash_course",
    homepage: null,
    size: 6,
    stargazers_count: 85,
    watchers_count: 85,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 120,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 120,
    open_issues: 0,
    watchers: 85,
    default_branch: "master",
  },
  {
    id: 222449927,
    node_id: "MDEwOlJlcG9zaXRvcnkyMjI0NDk5Mjc=",
    name: "jsdoc-examples",
    full_name: "bradtraversy/jsdoc-examples",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/jsdoc-examples",
    description: "Examples of using JSDoc to document JavaScript",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/jsdoc-examples",
    forks_url: "https://api.github.com/repos/bradtraversy/jsdoc-examples/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/jsdoc-examples/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/jsdoc-examples/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/jsdoc-examples/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/jsdoc-examples/deployments",
    created_at: "2019-11-18T12:58:59Z",
    updated_at: "2021-09-22T09:01:31Z",
    pushed_at: "2021-05-10T19:37:59Z",
    git_url: "git://github.com/bradtraversy/jsdoc-examples.git",
    ssh_url: "git@github.com:bradtraversy/jsdoc-examples.git",
    clone_url: "https://github.com/bradtraversy/jsdoc-examples.git",
    svn_url: "https://github.com/bradtraversy/jsdoc-examples",
    homepage: null,
    size: 385,
    stargazers_count: 91,
    watchers_count: 91,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 35,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 35,
    open_issues: 1,
    watchers: 91,
    default_branch: "master",
  },
  {
    id: 338104676,
    node_id: "MDEwOlJlcG9zaXRvcnkzMzgxMDQ2NzY=",
    name: "keystone-blog",
    full_name: "bradtraversy/keystone-blog",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/keystone-blog",
    description: "GraphQL Blog API built with KeystoneJS",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/keystone-blog",
    forks_url: "https://api.github.com/repos/bradtraversy/keystone-blog/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/keystone-blog/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/keystone-blog/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/keystone-blog/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/keystone-blog/deployments",
    created_at: "2021-02-11T17:45:06Z",
    updated_at: "2021-11-03T19:18:57Z",
    pushed_at: "2021-02-11T20:30:03Z",
    git_url: "git://github.com/bradtraversy/keystone-blog.git",
    ssh_url: "git@github.com:bradtraversy/keystone-blog.git",
    clone_url: "https://github.com/bradtraversy/keystone-blog.git",
    svn_url: "https://github.com/bradtraversy/keystone-blog",
    homepage: null,
    size: 310,
    stargazers_count: 71,
    watchers_count: 71,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 12,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 12,
    open_issues: 0,
    watchers: 71,
    default_branch: "master",
  },
  {
    id: 353365370,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTMzNjUzNzA=",
    name: "laravel-sanctum-api",
    full_name: "bradtraversy/laravel-sanctum-api",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/laravel-sanctum-api",
    description: "REST API with auth using Laravel 8 and Sanctum",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/laravel-sanctum-api",
    forks_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/laravel-sanctum-api/deployments",
    created_at: "2021-03-31T13:23:55Z",
    updated_at: "2021-10-28T23:27:00Z",
    pushed_at: "2021-06-02T11:30:30Z",
    git_url: "git://github.com/bradtraversy/laravel-sanctum-api.git",
    ssh_url: "git@github.com:bradtraversy/laravel-sanctum-api.git",
    clone_url: "https://github.com/bradtraversy/laravel-sanctum-api.git",
    svn_url: "https://github.com/bradtraversy/laravel-sanctum-api",
    homepage: null,
    size: 73,
    stargazers_count: 160,
    watchers_count: 160,
    language: "PHP",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 66,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 66,
    open_issues: 1,
    watchers: 160,
    default_branch: "master",
  },
  {
    id: 115763667,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTU3NjM2Njc=",
    name: "larticles_api",
    full_name: "bradtraversy/larticles_api",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/larticles_api",
    description: "Laravel 5.5 API using resources",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/larticles_api",
    forks_url: "https://api.github.com/repos/bradtraversy/larticles_api/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/bradtraversy/larticles_api/teams",
    hooks_url: "https://api.github.com/repos/bradtraversy/larticles_api/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/branches{/branch}",
    tags_url: "https://api.github.com/repos/bradtraversy/larticles_api/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/larticles_api/deployments",
    created_at: "2017-12-30T00:34:09Z",
    updated_at: "2021-10-17T16:59:14Z",
    pushed_at: "2021-10-05T21:25:16Z",
    git_url: "git://github.com/bradtraversy/larticles_api.git",
    ssh_url: "git@github.com:bradtraversy/larticles_api.git",
    clone_url: "https://github.com/bradtraversy/larticles_api.git",
    svn_url: "https://github.com/bradtraversy/larticles_api",
    homepage: null,
    size: 1081,
    stargazers_count: 176,
    watchers_count: 176,
    language: "PHP",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 132,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 132,
    open_issues: 6,
    watchers: 176,
    default_branch: "master",
  },
  {
    id: 122106288,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjIxMDYyODg=",
    name: "larticles_vue_app",
    full_name: "bradtraversy/larticles_vue_app",
    private: false,
    owner: {
      login: "bradtraversy",
      id: 5550850,
      node_id: "MDQ6VXNlcjU1NTA4NTA=",
      avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/bradtraversy",
      html_url: "https://github.com/bradtraversy",
      followers_url: "https://api.github.com/users/bradtraversy/followers",
      following_url:
        "https://api.github.com/users/bradtraversy/following{/other_user}",
      gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/bradtraversy/subscriptions",
      organizations_url: "https://api.github.com/users/bradtraversy/orgs",
      repos_url: "https://api.github.com/users/bradtraversy/repos",
      events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/bradtraversy/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/bradtraversy/larticles_vue_app",
    description: "Laravel 5.5 API with a Vue.js frontend",
    fork: false,
    url: "https://api.github.com/repos/bradtraversy/larticles_vue_app",
    forks_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/forks",
    keys_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/teams",
    hooks_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/hooks",
    issue_events_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/events",
    assignees_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/tags",
    blobs_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/languages",
    stargazers_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/stargazers",
    contributors_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/contributors",
    subscribers_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/subscribers",
    subscription_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/subscription",
    commits_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/merges",
    archive_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/downloads",
    issues_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/bradtraversy/larticles_vue_app/deployments",
    created_at: "2018-02-19T18:54:07Z",
    updated_at: "2021-11-03T17:15:49Z",
    pushed_at: "2018-08-20T12:30:47Z",
    git_url: "git://github.com/bradtraversy/larticles_vue_app.git",
    ssh_url: "git@github.com:bradtraversy/larticles_vue_app.git",
    clone_url: "https://github.com/bradtraversy/larticles_vue_app.git",
    svn_url: "https://github.com/bradtraversy/larticles_vue_app",
    homepage: null,
    size: 679,
    stargazers_count: 113,
    watchers_count: 113,
    language: "PHP",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 101,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: "public",
    forks: 101,
    open_issues: 6,
    watchers: 113,
    default_branch: "master",
  },
];
export default mock;
